/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const SpanLogPartialSpanMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of a SpanLogPartialSpanMessage.
     * @exports ISpanLogPartialSpanMessage
     * @interface ISpanLogPartialSpanMessage
     * @property {string} key SpanLogPartialSpanMessage key
     * @property {Uint8Array|null} [value] SpanLogPartialSpanMessage value
     * @property {string} startPosition SpanLogPartialSpanMessage startPosition
     * @property {string|null} [endPosition] SpanLogPartialSpanMessage endPosition
     * @property {boolean|null} [endClosed] SpanLogPartialSpanMessage endClosed
     */

    /**
     * Constructs a new SpanLogPartialSpanMessage.
     * @exports SpanLogPartialSpanMessage
     * @classdesc Represents a SpanLogPartialSpanMessage.
     * @implements ISpanLogPartialSpanMessage
     * @constructor
     * @param {ISpanLogPartialSpanMessage=} [properties] Properties to set
     */
    function SpanLogPartialSpanMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SpanLogPartialSpanMessage key.
     * @member {string} key
     * @memberof SpanLogPartialSpanMessage
     * @instance
     */
    SpanLogPartialSpanMessage.prototype.key = "";

    /**
     * SpanLogPartialSpanMessage value.
     * @member {Uint8Array} value
     * @memberof SpanLogPartialSpanMessage
     * @instance
     */
    SpanLogPartialSpanMessage.prototype.value = $util.newBuffer([]);

    /**
     * SpanLogPartialSpanMessage startPosition.
     * @member {string} startPosition
     * @memberof SpanLogPartialSpanMessage
     * @instance
     */
    SpanLogPartialSpanMessage.prototype.startPosition = "";

    /**
     * SpanLogPartialSpanMessage endPosition.
     * @member {string} endPosition
     * @memberof SpanLogPartialSpanMessage
     * @instance
     */
    SpanLogPartialSpanMessage.prototype.endPosition = "";

    /**
     * SpanLogPartialSpanMessage endClosed.
     * @member {boolean} endClosed
     * @memberof SpanLogPartialSpanMessage
     * @instance
     */
    SpanLogPartialSpanMessage.prototype.endClosed = false;

    /**
     * Creates a new SpanLogPartialSpanMessage instance using the specified properties.
     * @function create
     * @memberof SpanLogPartialSpanMessage
     * @static
     * @param {ISpanLogPartialSpanMessage=} [properties] Properties to set
     * @returns {SpanLogPartialSpanMessage} SpanLogPartialSpanMessage instance
     */
    SpanLogPartialSpanMessage.create = function create(properties) {
        return new SpanLogPartialSpanMessage(properties);
    };

    /**
     * Encodes the specified SpanLogPartialSpanMessage message. Does not implicitly {@link SpanLogPartialSpanMessage.verify|verify} messages.
     * @function encode
     * @memberof SpanLogPartialSpanMessage
     * @static
     * @param {ISpanLogPartialSpanMessage} message SpanLogPartialSpanMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SpanLogPartialSpanMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.value);
        writer.uint32(/* id 3, wireType 2 =*/26).string(message.startPosition);
        if (message.endPosition != null && Object.hasOwnProperty.call(message, "endPosition"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.endPosition);
        if (message.endClosed != null && Object.hasOwnProperty.call(message, "endClosed"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.endClosed);
        return writer;
    };

    /**
     * Encodes the specified SpanLogPartialSpanMessage message, length delimited. Does not implicitly {@link SpanLogPartialSpanMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SpanLogPartialSpanMessage
     * @static
     * @param {ISpanLogPartialSpanMessage} message SpanLogPartialSpanMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SpanLogPartialSpanMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SpanLogPartialSpanMessage message from the specified reader or buffer.
     * @function decode
     * @memberof SpanLogPartialSpanMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SpanLogPartialSpanMessage} SpanLogPartialSpanMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SpanLogPartialSpanMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new SpanLogPartialSpanMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.key = reader.string();
                break;
            case 2:
                message.value = reader.bytes();
                break;
            case 3:
                message.startPosition = reader.string();
                break;
            case 4:
                message.endPosition = reader.string();
                break;
            case 5:
                message.endClosed = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("key"))
            throw $util.ProtocolError("missing required 'key'", { instance: message });
        if (!message.hasOwnProperty("startPosition"))
            throw $util.ProtocolError("missing required 'startPosition'", { instance: message });
        return message;
    };

    /**
     * Decodes a SpanLogPartialSpanMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SpanLogPartialSpanMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SpanLogPartialSpanMessage} SpanLogPartialSpanMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SpanLogPartialSpanMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SpanLogPartialSpanMessage message.
     * @function verify
     * @memberof SpanLogPartialSpanMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SpanLogPartialSpanMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.key))
            return "key: string expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                return "value: buffer expected";
        if (!$util.isString(message.startPosition))
            return "startPosition: string expected";
        if (message.endPosition != null && message.hasOwnProperty("endPosition"))
            if (!$util.isString(message.endPosition))
                return "endPosition: string expected";
        if (message.endClosed != null && message.hasOwnProperty("endClosed"))
            if (typeof message.endClosed !== "boolean")
                return "endClosed: boolean expected";
        return null;
    };

    /**
     * Creates a SpanLogPartialSpanMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SpanLogPartialSpanMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SpanLogPartialSpanMessage} SpanLogPartialSpanMessage
     */
    SpanLogPartialSpanMessage.fromObject = function fromObject(object) {
        if (object instanceof SpanLogPartialSpanMessage)
            return object;
        let message = new SpanLogPartialSpanMessage();
        if (object.key != null)
            message.key = String(object.key);
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.startPosition != null)
            message.startPosition = String(object.startPosition);
        if (object.endPosition != null)
            message.endPosition = String(object.endPosition);
        if (object.endClosed != null)
            message.endClosed = Boolean(object.endClosed);
        return message;
    };

    /**
     * Creates a plain object from a SpanLogPartialSpanMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SpanLogPartialSpanMessage
     * @static
     * @param {SpanLogPartialSpanMessage} message SpanLogPartialSpanMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SpanLogPartialSpanMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.key = "";
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            object.startPosition = "";
            object.endPosition = "";
            object.endClosed = false;
        }
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = message.key;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.startPosition != null && message.hasOwnProperty("startPosition"))
            object.startPosition = message.startPosition;
        if (message.endPosition != null && message.hasOwnProperty("endPosition"))
            object.endPosition = message.endPosition;
        if (message.endClosed != null && message.hasOwnProperty("endClosed"))
            object.endClosed = message.endClosed;
        return object;
    };

    /**
     * Converts this SpanLogPartialSpanMessage to JSON.
     * @function toJSON
     * @memberof SpanLogPartialSpanMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SpanLogPartialSpanMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SpanLogPartialSpanMessage;
})();

export const SpanLogSaveMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of a SpanLogSaveMessage.
     * @exports ISpanLogSaveMessage
     * @interface ISpanLogSaveMessage
     * @property {Array.<string>|null} [senderIDs] SpanLogSaveMessage senderIDs
     * @property {Array.<number>|null} [lengths] SpanLogSaveMessage lengths
     * @property {Array.<Uint8Array>|null} [spans] SpanLogSaveMessage spans
     * @property {Array.<number|Long>|null} [lamports] SpanLogSaveMessage lamports
     */

    /**
     * Constructs a new SpanLogSaveMessage.
     * @exports SpanLogSaveMessage
     * @classdesc Represents a SpanLogSaveMessage.
     * @implements ISpanLogSaveMessage
     * @constructor
     * @param {ISpanLogSaveMessage=} [properties] Properties to set
     */
    function SpanLogSaveMessage(properties) {
        this.senderIDs = [];
        this.lengths = [];
        this.spans = [];
        this.lamports = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SpanLogSaveMessage senderIDs.
     * @member {Array.<string>} senderIDs
     * @memberof SpanLogSaveMessage
     * @instance
     */
    SpanLogSaveMessage.prototype.senderIDs = $util.emptyArray;

    /**
     * SpanLogSaveMessage lengths.
     * @member {Array.<number>} lengths
     * @memberof SpanLogSaveMessage
     * @instance
     */
    SpanLogSaveMessage.prototype.lengths = $util.emptyArray;

    /**
     * SpanLogSaveMessage spans.
     * @member {Array.<Uint8Array>} spans
     * @memberof SpanLogSaveMessage
     * @instance
     */
    SpanLogSaveMessage.prototype.spans = $util.emptyArray;

    /**
     * SpanLogSaveMessage lamports.
     * @member {Array.<number|Long>} lamports
     * @memberof SpanLogSaveMessage
     * @instance
     */
    SpanLogSaveMessage.prototype.lamports = $util.emptyArray;

    /**
     * Creates a new SpanLogSaveMessage instance using the specified properties.
     * @function create
     * @memberof SpanLogSaveMessage
     * @static
     * @param {ISpanLogSaveMessage=} [properties] Properties to set
     * @returns {SpanLogSaveMessage} SpanLogSaveMessage instance
     */
    SpanLogSaveMessage.create = function create(properties) {
        return new SpanLogSaveMessage(properties);
    };

    /**
     * Encodes the specified SpanLogSaveMessage message. Does not implicitly {@link SpanLogSaveMessage.verify|verify} messages.
     * @function encode
     * @memberof SpanLogSaveMessage
     * @static
     * @param {ISpanLogSaveMessage} message SpanLogSaveMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SpanLogSaveMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.senderIDs != null && message.senderIDs.length)
            for (let i = 0; i < message.senderIDs.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.senderIDs[i]);
        if (message.lengths != null && message.lengths.length) {
            writer.uint32(/* id 2, wireType 2 =*/18).fork();
            for (let i = 0; i < message.lengths.length; ++i)
                writer.uint32(message.lengths[i]);
            writer.ldelim();
        }
        if (message.spans != null && message.spans.length)
            for (let i = 0; i < message.spans.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.spans[i]);
        if (message.lamports != null && message.lamports.length) {
            writer.uint32(/* id 4, wireType 2 =*/34).fork();
            for (let i = 0; i < message.lamports.length; ++i)
                writer.uint64(message.lamports[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified SpanLogSaveMessage message, length delimited. Does not implicitly {@link SpanLogSaveMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SpanLogSaveMessage
     * @static
     * @param {ISpanLogSaveMessage} message SpanLogSaveMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SpanLogSaveMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SpanLogSaveMessage message from the specified reader or buffer.
     * @function decode
     * @memberof SpanLogSaveMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SpanLogSaveMessage} SpanLogSaveMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SpanLogSaveMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new SpanLogSaveMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.senderIDs && message.senderIDs.length))
                    message.senderIDs = [];
                message.senderIDs.push(reader.string());
                break;
            case 2:
                if (!(message.lengths && message.lengths.length))
                    message.lengths = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.lengths.push(reader.uint32());
                } else
                    message.lengths.push(reader.uint32());
                break;
            case 3:
                if (!(message.spans && message.spans.length))
                    message.spans = [];
                message.spans.push(reader.bytes());
                break;
            case 4:
                if (!(message.lamports && message.lamports.length))
                    message.lamports = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.lamports.push(reader.uint64());
                } else
                    message.lamports.push(reader.uint64());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SpanLogSaveMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SpanLogSaveMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SpanLogSaveMessage} SpanLogSaveMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SpanLogSaveMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SpanLogSaveMessage message.
     * @function verify
     * @memberof SpanLogSaveMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SpanLogSaveMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.senderIDs != null && message.hasOwnProperty("senderIDs")) {
            if (!Array.isArray(message.senderIDs))
                return "senderIDs: array expected";
            for (let i = 0; i < message.senderIDs.length; ++i)
                if (!$util.isString(message.senderIDs[i]))
                    return "senderIDs: string[] expected";
        }
        if (message.lengths != null && message.hasOwnProperty("lengths")) {
            if (!Array.isArray(message.lengths))
                return "lengths: array expected";
            for (let i = 0; i < message.lengths.length; ++i)
                if (!$util.isInteger(message.lengths[i]))
                    return "lengths: integer[] expected";
        }
        if (message.spans != null && message.hasOwnProperty("spans")) {
            if (!Array.isArray(message.spans))
                return "spans: array expected";
            for (let i = 0; i < message.spans.length; ++i)
                if (!(message.spans[i] && typeof message.spans[i].length === "number" || $util.isString(message.spans[i])))
                    return "spans: buffer[] expected";
        }
        if (message.lamports != null && message.hasOwnProperty("lamports")) {
            if (!Array.isArray(message.lamports))
                return "lamports: array expected";
            for (let i = 0; i < message.lamports.length; ++i)
                if (!$util.isInteger(message.lamports[i]) && !(message.lamports[i] && $util.isInteger(message.lamports[i].low) && $util.isInteger(message.lamports[i].high)))
                    return "lamports: integer|Long[] expected";
        }
        return null;
    };

    /**
     * Creates a SpanLogSaveMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SpanLogSaveMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SpanLogSaveMessage} SpanLogSaveMessage
     */
    SpanLogSaveMessage.fromObject = function fromObject(object) {
        if (object instanceof SpanLogSaveMessage)
            return object;
        let message = new SpanLogSaveMessage();
        if (object.senderIDs) {
            if (!Array.isArray(object.senderIDs))
                throw TypeError(".SpanLogSaveMessage.senderIDs: array expected");
            message.senderIDs = [];
            for (let i = 0; i < object.senderIDs.length; ++i)
                message.senderIDs[i] = String(object.senderIDs[i]);
        }
        if (object.lengths) {
            if (!Array.isArray(object.lengths))
                throw TypeError(".SpanLogSaveMessage.lengths: array expected");
            message.lengths = [];
            for (let i = 0; i < object.lengths.length; ++i)
                message.lengths[i] = object.lengths[i] >>> 0;
        }
        if (object.spans) {
            if (!Array.isArray(object.spans))
                throw TypeError(".SpanLogSaveMessage.spans: array expected");
            message.spans = [];
            for (let i = 0; i < object.spans.length; ++i)
                if (typeof object.spans[i] === "string")
                    $util.base64.decode(object.spans[i], message.spans[i] = $util.newBuffer($util.base64.length(object.spans[i])), 0);
                else if (object.spans[i].length)
                    message.spans[i] = object.spans[i];
        }
        if (object.lamports) {
            if (!Array.isArray(object.lamports))
                throw TypeError(".SpanLogSaveMessage.lamports: array expected");
            message.lamports = [];
            for (let i = 0; i < object.lamports.length; ++i)
                if ($util.Long)
                    (message.lamports[i] = $util.Long.fromValue(object.lamports[i])).unsigned = true;
                else if (typeof object.lamports[i] === "string")
                    message.lamports[i] = parseInt(object.lamports[i], 10);
                else if (typeof object.lamports[i] === "number")
                    message.lamports[i] = object.lamports[i];
                else if (typeof object.lamports[i] === "object")
                    message.lamports[i] = new $util.LongBits(object.lamports[i].low >>> 0, object.lamports[i].high >>> 0).toNumber(true);
        }
        return message;
    };

    /**
     * Creates a plain object from a SpanLogSaveMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SpanLogSaveMessage
     * @static
     * @param {SpanLogSaveMessage} message SpanLogSaveMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SpanLogSaveMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.senderIDs = [];
            object.lengths = [];
            object.spans = [];
            object.lamports = [];
        }
        if (message.senderIDs && message.senderIDs.length) {
            object.senderIDs = [];
            for (let j = 0; j < message.senderIDs.length; ++j)
                object.senderIDs[j] = message.senderIDs[j];
        }
        if (message.lengths && message.lengths.length) {
            object.lengths = [];
            for (let j = 0; j < message.lengths.length; ++j)
                object.lengths[j] = message.lengths[j];
        }
        if (message.spans && message.spans.length) {
            object.spans = [];
            for (let j = 0; j < message.spans.length; ++j)
                object.spans[j] = options.bytes === String ? $util.base64.encode(message.spans[j], 0, message.spans[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.spans[j]) : message.spans[j];
        }
        if (message.lamports && message.lamports.length) {
            object.lamports = [];
            for (let j = 0; j < message.lamports.length; ++j)
                if (typeof message.lamports[j] === "number")
                    object.lamports[j] = options.longs === String ? String(message.lamports[j]) : message.lamports[j];
                else
                    object.lamports[j] = options.longs === String ? $util.Long.prototype.toString.call(message.lamports[j]) : options.longs === Number ? new $util.LongBits(message.lamports[j].low >>> 0, message.lamports[j].high >>> 0).toNumber(true) : message.lamports[j];
        }
        return object;
    };

    /**
     * Converts this SpanLogSaveMessage to JSON.
     * @function toJSON
     * @memberof SpanLogSaveMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SpanLogSaveMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SpanLogSaveMessage;
})();

export const TotalOrderCreateMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of a TotalOrderCreateMessage.
     * @exports ITotalOrderCreateMessage
     * @interface ITotalOrderCreateMessage
     * @property {string|null} [parentWaypointSenderID] TotalOrderCreateMessage parentWaypointSenderID
     * @property {number} parentWaypointCounterAndSide TotalOrderCreateMessage parentWaypointCounterAndSide
     * @property {number} parentValueIndex TotalOrderCreateMessage parentValueIndex
     */

    /**
     * Constructs a new TotalOrderCreateMessage.
     * @exports TotalOrderCreateMessage
     * @classdesc Represents a TotalOrderCreateMessage.
     * @implements ITotalOrderCreateMessage
     * @constructor
     * @param {ITotalOrderCreateMessage=} [properties] Properties to set
     */
    function TotalOrderCreateMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TotalOrderCreateMessage parentWaypointSenderID.
     * @member {string} parentWaypointSenderID
     * @memberof TotalOrderCreateMessage
     * @instance
     */
    TotalOrderCreateMessage.prototype.parentWaypointSenderID = "";

    /**
     * TotalOrderCreateMessage parentWaypointCounterAndSide.
     * @member {number} parentWaypointCounterAndSide
     * @memberof TotalOrderCreateMessage
     * @instance
     */
    TotalOrderCreateMessage.prototype.parentWaypointCounterAndSide = 0;

    /**
     * TotalOrderCreateMessage parentValueIndex.
     * @member {number} parentValueIndex
     * @memberof TotalOrderCreateMessage
     * @instance
     */
    TotalOrderCreateMessage.prototype.parentValueIndex = 0;

    /**
     * Creates a new TotalOrderCreateMessage instance using the specified properties.
     * @function create
     * @memberof TotalOrderCreateMessage
     * @static
     * @param {ITotalOrderCreateMessage=} [properties] Properties to set
     * @returns {TotalOrderCreateMessage} TotalOrderCreateMessage instance
     */
    TotalOrderCreateMessage.create = function create(properties) {
        return new TotalOrderCreateMessage(properties);
    };

    /**
     * Encodes the specified TotalOrderCreateMessage message. Does not implicitly {@link TotalOrderCreateMessage.verify|verify} messages.
     * @function encode
     * @memberof TotalOrderCreateMessage
     * @static
     * @param {ITotalOrderCreateMessage} message TotalOrderCreateMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TotalOrderCreateMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.parentWaypointSenderID != null && Object.hasOwnProperty.call(message, "parentWaypointSenderID"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.parentWaypointSenderID);
        writer.uint32(/* id 2, wireType 0 =*/16).sint32(message.parentWaypointCounterAndSide);
        writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.parentValueIndex);
        return writer;
    };

    /**
     * Encodes the specified TotalOrderCreateMessage message, length delimited. Does not implicitly {@link TotalOrderCreateMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TotalOrderCreateMessage
     * @static
     * @param {ITotalOrderCreateMessage} message TotalOrderCreateMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TotalOrderCreateMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TotalOrderCreateMessage message from the specified reader or buffer.
     * @function decode
     * @memberof TotalOrderCreateMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TotalOrderCreateMessage} TotalOrderCreateMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TotalOrderCreateMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new TotalOrderCreateMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.parentWaypointSenderID = reader.string();
                break;
            case 2:
                message.parentWaypointCounterAndSide = reader.sint32();
                break;
            case 3:
                message.parentValueIndex = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("parentWaypointCounterAndSide"))
            throw $util.ProtocolError("missing required 'parentWaypointCounterAndSide'", { instance: message });
        if (!message.hasOwnProperty("parentValueIndex"))
            throw $util.ProtocolError("missing required 'parentValueIndex'", { instance: message });
        return message;
    };

    /**
     * Decodes a TotalOrderCreateMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TotalOrderCreateMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TotalOrderCreateMessage} TotalOrderCreateMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TotalOrderCreateMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TotalOrderCreateMessage message.
     * @function verify
     * @memberof TotalOrderCreateMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TotalOrderCreateMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.parentWaypointSenderID != null && message.hasOwnProperty("parentWaypointSenderID"))
            if (!$util.isString(message.parentWaypointSenderID))
                return "parentWaypointSenderID: string expected";
        if (!$util.isInteger(message.parentWaypointCounterAndSide))
            return "parentWaypointCounterAndSide: integer expected";
        if (!$util.isInteger(message.parentValueIndex))
            return "parentValueIndex: integer expected";
        return null;
    };

    /**
     * Creates a TotalOrderCreateMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TotalOrderCreateMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TotalOrderCreateMessage} TotalOrderCreateMessage
     */
    TotalOrderCreateMessage.fromObject = function fromObject(object) {
        if (object instanceof TotalOrderCreateMessage)
            return object;
        let message = new TotalOrderCreateMessage();
        if (object.parentWaypointSenderID != null)
            message.parentWaypointSenderID = String(object.parentWaypointSenderID);
        if (object.parentWaypointCounterAndSide != null)
            message.parentWaypointCounterAndSide = object.parentWaypointCounterAndSide | 0;
        if (object.parentValueIndex != null)
            message.parentValueIndex = object.parentValueIndex >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a TotalOrderCreateMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TotalOrderCreateMessage
     * @static
     * @param {TotalOrderCreateMessage} message TotalOrderCreateMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TotalOrderCreateMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.parentWaypointSenderID = "";
            object.parentWaypointCounterAndSide = 0;
            object.parentValueIndex = 0;
        }
        if (message.parentWaypointSenderID != null && message.hasOwnProperty("parentWaypointSenderID"))
            object.parentWaypointSenderID = message.parentWaypointSenderID;
        if (message.parentWaypointCounterAndSide != null && message.hasOwnProperty("parentWaypointCounterAndSide"))
            object.parentWaypointCounterAndSide = message.parentWaypointCounterAndSide;
        if (message.parentValueIndex != null && message.hasOwnProperty("parentValueIndex"))
            object.parentValueIndex = message.parentValueIndex;
        return object;
    };

    /**
     * Converts this TotalOrderCreateMessage to JSON.
     * @function toJSON
     * @memberof TotalOrderCreateMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TotalOrderCreateMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TotalOrderCreateMessage;
})();

export const TotalOrderSave = /*@__PURE__*/ (() => {

    /**
     * Properties of a TotalOrderSave.
     * @exports ITotalOrderSave
     * @interface ITotalOrderSave
     * @property {Array.<string>|null} [replicaIDs] TotalOrderSave replicaIDs
     * @property {Array.<number>|null} [replicaCounts] TotalOrderSave replicaCounts
     * @property {Array.<number>|null} [parentWaypoints] TotalOrderSave parentWaypoints
     * @property {Array.<number>|null} [parentValueIndexAndSides] TotalOrderSave parentValueIndexAndSides
     */

    /**
     * Constructs a new TotalOrderSave.
     * @exports TotalOrderSave
     * @classdesc Represents a TotalOrderSave.
     * @implements ITotalOrderSave
     * @constructor
     * @param {ITotalOrderSave=} [properties] Properties to set
     */
    function TotalOrderSave(properties) {
        this.replicaIDs = [];
        this.replicaCounts = [];
        this.parentWaypoints = [];
        this.parentValueIndexAndSides = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TotalOrderSave replicaIDs.
     * @member {Array.<string>} replicaIDs
     * @memberof TotalOrderSave
     * @instance
     */
    TotalOrderSave.prototype.replicaIDs = $util.emptyArray;

    /**
     * TotalOrderSave replicaCounts.
     * @member {Array.<number>} replicaCounts
     * @memberof TotalOrderSave
     * @instance
     */
    TotalOrderSave.prototype.replicaCounts = $util.emptyArray;

    /**
     * TotalOrderSave parentWaypoints.
     * @member {Array.<number>} parentWaypoints
     * @memberof TotalOrderSave
     * @instance
     */
    TotalOrderSave.prototype.parentWaypoints = $util.emptyArray;

    /**
     * TotalOrderSave parentValueIndexAndSides.
     * @member {Array.<number>} parentValueIndexAndSides
     * @memberof TotalOrderSave
     * @instance
     */
    TotalOrderSave.prototype.parentValueIndexAndSides = $util.emptyArray;

    /**
     * Creates a new TotalOrderSave instance using the specified properties.
     * @function create
     * @memberof TotalOrderSave
     * @static
     * @param {ITotalOrderSave=} [properties] Properties to set
     * @returns {TotalOrderSave} TotalOrderSave instance
     */
    TotalOrderSave.create = function create(properties) {
        return new TotalOrderSave(properties);
    };

    /**
     * Encodes the specified TotalOrderSave message. Does not implicitly {@link TotalOrderSave.verify|verify} messages.
     * @function encode
     * @memberof TotalOrderSave
     * @static
     * @param {ITotalOrderSave} message TotalOrderSave message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TotalOrderSave.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.replicaIDs != null && message.replicaIDs.length)
            for (let i = 0; i < message.replicaIDs.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.replicaIDs[i]);
        if (message.replicaCounts != null && message.replicaCounts.length) {
            writer.uint32(/* id 2, wireType 2 =*/18).fork();
            for (let i = 0; i < message.replicaCounts.length; ++i)
                writer.uint32(message.replicaCounts[i]);
            writer.ldelim();
        }
        if (message.parentWaypoints != null && message.parentWaypoints.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.parentWaypoints.length; ++i)
                writer.uint32(message.parentWaypoints[i]);
            writer.ldelim();
        }
        if (message.parentValueIndexAndSides != null && message.parentValueIndexAndSides.length) {
            writer.uint32(/* id 4, wireType 2 =*/34).fork();
            for (let i = 0; i < message.parentValueIndexAndSides.length; ++i)
                writer.sint32(message.parentValueIndexAndSides[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified TotalOrderSave message, length delimited. Does not implicitly {@link TotalOrderSave.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TotalOrderSave
     * @static
     * @param {ITotalOrderSave} message TotalOrderSave message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TotalOrderSave.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TotalOrderSave message from the specified reader or buffer.
     * @function decode
     * @memberof TotalOrderSave
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TotalOrderSave} TotalOrderSave
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TotalOrderSave.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new TotalOrderSave();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.replicaIDs && message.replicaIDs.length))
                    message.replicaIDs = [];
                message.replicaIDs.push(reader.string());
                break;
            case 2:
                if (!(message.replicaCounts && message.replicaCounts.length))
                    message.replicaCounts = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.replicaCounts.push(reader.uint32());
                } else
                    message.replicaCounts.push(reader.uint32());
                break;
            case 3:
                if (!(message.parentWaypoints && message.parentWaypoints.length))
                    message.parentWaypoints = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.parentWaypoints.push(reader.uint32());
                } else
                    message.parentWaypoints.push(reader.uint32());
                break;
            case 4:
                if (!(message.parentValueIndexAndSides && message.parentValueIndexAndSides.length))
                    message.parentValueIndexAndSides = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.parentValueIndexAndSides.push(reader.sint32());
                } else
                    message.parentValueIndexAndSides.push(reader.sint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TotalOrderSave message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TotalOrderSave
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TotalOrderSave} TotalOrderSave
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TotalOrderSave.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TotalOrderSave message.
     * @function verify
     * @memberof TotalOrderSave
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TotalOrderSave.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.replicaIDs != null && message.hasOwnProperty("replicaIDs")) {
            if (!Array.isArray(message.replicaIDs))
                return "replicaIDs: array expected";
            for (let i = 0; i < message.replicaIDs.length; ++i)
                if (!$util.isString(message.replicaIDs[i]))
                    return "replicaIDs: string[] expected";
        }
        if (message.replicaCounts != null && message.hasOwnProperty("replicaCounts")) {
            if (!Array.isArray(message.replicaCounts))
                return "replicaCounts: array expected";
            for (let i = 0; i < message.replicaCounts.length; ++i)
                if (!$util.isInteger(message.replicaCounts[i]))
                    return "replicaCounts: integer[] expected";
        }
        if (message.parentWaypoints != null && message.hasOwnProperty("parentWaypoints")) {
            if (!Array.isArray(message.parentWaypoints))
                return "parentWaypoints: array expected";
            for (let i = 0; i < message.parentWaypoints.length; ++i)
                if (!$util.isInteger(message.parentWaypoints[i]))
                    return "parentWaypoints: integer[] expected";
        }
        if (message.parentValueIndexAndSides != null && message.hasOwnProperty("parentValueIndexAndSides")) {
            if (!Array.isArray(message.parentValueIndexAndSides))
                return "parentValueIndexAndSides: array expected";
            for (let i = 0; i < message.parentValueIndexAndSides.length; ++i)
                if (!$util.isInteger(message.parentValueIndexAndSides[i]))
                    return "parentValueIndexAndSides: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a TotalOrderSave message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TotalOrderSave
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TotalOrderSave} TotalOrderSave
     */
    TotalOrderSave.fromObject = function fromObject(object) {
        if (object instanceof TotalOrderSave)
            return object;
        let message = new TotalOrderSave();
        if (object.replicaIDs) {
            if (!Array.isArray(object.replicaIDs))
                throw TypeError(".TotalOrderSave.replicaIDs: array expected");
            message.replicaIDs = [];
            for (let i = 0; i < object.replicaIDs.length; ++i)
                message.replicaIDs[i] = String(object.replicaIDs[i]);
        }
        if (object.replicaCounts) {
            if (!Array.isArray(object.replicaCounts))
                throw TypeError(".TotalOrderSave.replicaCounts: array expected");
            message.replicaCounts = [];
            for (let i = 0; i < object.replicaCounts.length; ++i)
                message.replicaCounts[i] = object.replicaCounts[i] >>> 0;
        }
        if (object.parentWaypoints) {
            if (!Array.isArray(object.parentWaypoints))
                throw TypeError(".TotalOrderSave.parentWaypoints: array expected");
            message.parentWaypoints = [];
            for (let i = 0; i < object.parentWaypoints.length; ++i)
                message.parentWaypoints[i] = object.parentWaypoints[i] >>> 0;
        }
        if (object.parentValueIndexAndSides) {
            if (!Array.isArray(object.parentValueIndexAndSides))
                throw TypeError(".TotalOrderSave.parentValueIndexAndSides: array expected");
            message.parentValueIndexAndSides = [];
            for (let i = 0; i < object.parentValueIndexAndSides.length; ++i)
                message.parentValueIndexAndSides[i] = object.parentValueIndexAndSides[i] | 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a TotalOrderSave message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TotalOrderSave
     * @static
     * @param {TotalOrderSave} message TotalOrderSave
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TotalOrderSave.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.replicaIDs = [];
            object.replicaCounts = [];
            object.parentWaypoints = [];
            object.parentValueIndexAndSides = [];
        }
        if (message.replicaIDs && message.replicaIDs.length) {
            object.replicaIDs = [];
            for (let j = 0; j < message.replicaIDs.length; ++j)
                object.replicaIDs[j] = message.replicaIDs[j];
        }
        if (message.replicaCounts && message.replicaCounts.length) {
            object.replicaCounts = [];
            for (let j = 0; j < message.replicaCounts.length; ++j)
                object.replicaCounts[j] = message.replicaCounts[j];
        }
        if (message.parentWaypoints && message.parentWaypoints.length) {
            object.parentWaypoints = [];
            for (let j = 0; j < message.parentWaypoints.length; ++j)
                object.parentWaypoints[j] = message.parentWaypoints[j];
        }
        if (message.parentValueIndexAndSides && message.parentValueIndexAndSides.length) {
            object.parentValueIndexAndSides = [];
            for (let j = 0; j < message.parentValueIndexAndSides.length; ++j)
                object.parentValueIndexAndSides[j] = message.parentValueIndexAndSides[j];
        }
        return object;
    };

    /**
     * Converts this TotalOrderSave to JSON.
     * @function toJSON
     * @memberof TotalOrderSave
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TotalOrderSave.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TotalOrderSave;
})();

export const ValueListInsertMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of a ValueListInsertMessage.
     * @exports IValueListInsertMessage
     * @interface IValueListInsertMessage
     * @property {number} counter ValueListInsertMessage counter
     * @property {number|null} [valueIndex] ValueListInsertMessage valueIndex
     * @property {Uint8Array|null} [value] ValueListInsertMessage value
     * @property {Uint8Array|null} [valueArray] ValueListInsertMessage valueArray
     */

    /**
     * Constructs a new ValueListInsertMessage.
     * @exports ValueListInsertMessage
     * @classdesc Represents a ValueListInsertMessage.
     * @implements IValueListInsertMessage
     * @constructor
     * @param {IValueListInsertMessage=} [properties] Properties to set
     */
    function ValueListInsertMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ValueListInsertMessage counter.
     * @member {number} counter
     * @memberof ValueListInsertMessage
     * @instance
     */
    ValueListInsertMessage.prototype.counter = 0;

    /**
     * ValueListInsertMessage valueIndex.
     * @member {number} valueIndex
     * @memberof ValueListInsertMessage
     * @instance
     */
    ValueListInsertMessage.prototype.valueIndex = 0;

    /**
     * ValueListInsertMessage value.
     * @member {Uint8Array} value
     * @memberof ValueListInsertMessage
     * @instance
     */
    ValueListInsertMessage.prototype.value = $util.newBuffer([]);

    /**
     * ValueListInsertMessage valueArray.
     * @member {Uint8Array} valueArray
     * @memberof ValueListInsertMessage
     * @instance
     */
    ValueListInsertMessage.prototype.valueArray = $util.newBuffer([]);

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * ValueListInsertMessage data.
     * @member {"value"|"valueArray"|undefined} data
     * @memberof ValueListInsertMessage
     * @instance
     */
    Object.defineProperty(ValueListInsertMessage.prototype, "data", {
        get: $util.oneOfGetter($oneOfFields = ["value", "valueArray"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new ValueListInsertMessage instance using the specified properties.
     * @function create
     * @memberof ValueListInsertMessage
     * @static
     * @param {IValueListInsertMessage=} [properties] Properties to set
     * @returns {ValueListInsertMessage} ValueListInsertMessage instance
     */
    ValueListInsertMessage.create = function create(properties) {
        return new ValueListInsertMessage(properties);
    };

    /**
     * Encodes the specified ValueListInsertMessage message. Does not implicitly {@link ValueListInsertMessage.verify|verify} messages.
     * @function encode
     * @memberof ValueListInsertMessage
     * @static
     * @param {IValueListInsertMessage} message ValueListInsertMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ValueListInsertMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.counter);
        if (message.valueIndex != null && Object.hasOwnProperty.call(message, "valueIndex"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.valueIndex);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.value);
        if (message.valueArray != null && Object.hasOwnProperty.call(message, "valueArray"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.valueArray);
        return writer;
    };

    /**
     * Encodes the specified ValueListInsertMessage message, length delimited. Does not implicitly {@link ValueListInsertMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ValueListInsertMessage
     * @static
     * @param {IValueListInsertMessage} message ValueListInsertMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ValueListInsertMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ValueListInsertMessage message from the specified reader or buffer.
     * @function decode
     * @memberof ValueListInsertMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ValueListInsertMessage} ValueListInsertMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ValueListInsertMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new ValueListInsertMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.counter = reader.uint32();
                break;
            case 2:
                message.valueIndex = reader.uint32();
                break;
            case 3:
                message.value = reader.bytes();
                break;
            case 4:
                message.valueArray = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("counter"))
            throw $util.ProtocolError("missing required 'counter'", { instance: message });
        return message;
    };

    /**
     * Decodes a ValueListInsertMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ValueListInsertMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ValueListInsertMessage} ValueListInsertMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ValueListInsertMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ValueListInsertMessage message.
     * @function verify
     * @memberof ValueListInsertMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ValueListInsertMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        let properties = {};
        if (!$util.isInteger(message.counter))
            return "counter: integer expected";
        if (message.valueIndex != null && message.hasOwnProperty("valueIndex"))
            if (!$util.isInteger(message.valueIndex))
                return "valueIndex: integer expected";
        if (message.value != null && message.hasOwnProperty("value")) {
            properties.data = 1;
            if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                return "value: buffer expected";
        }
        if (message.valueArray != null && message.hasOwnProperty("valueArray")) {
            if (properties.data === 1)
                return "data: multiple values";
            properties.data = 1;
            if (!(message.valueArray && typeof message.valueArray.length === "number" || $util.isString(message.valueArray)))
                return "valueArray: buffer expected";
        }
        return null;
    };

    /**
     * Creates a ValueListInsertMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ValueListInsertMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ValueListInsertMessage} ValueListInsertMessage
     */
    ValueListInsertMessage.fromObject = function fromObject(object) {
        if (object instanceof ValueListInsertMessage)
            return object;
        let message = new ValueListInsertMessage();
        if (object.counter != null)
            message.counter = object.counter >>> 0;
        if (object.valueIndex != null)
            message.valueIndex = object.valueIndex >>> 0;
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.valueArray != null)
            if (typeof object.valueArray === "string")
                $util.base64.decode(object.valueArray, message.valueArray = $util.newBuffer($util.base64.length(object.valueArray)), 0);
            else if (object.valueArray.length)
                message.valueArray = object.valueArray;
        return message;
    };

    /**
     * Creates a plain object from a ValueListInsertMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ValueListInsertMessage
     * @static
     * @param {ValueListInsertMessage} message ValueListInsertMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ValueListInsertMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.counter = 0;
            object.valueIndex = 0;
        }
        if (message.counter != null && message.hasOwnProperty("counter"))
            object.counter = message.counter;
        if (message.valueIndex != null && message.hasOwnProperty("valueIndex"))
            object.valueIndex = message.valueIndex;
        if (message.value != null && message.hasOwnProperty("value")) {
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
            if (options.oneofs)
                object.data = "value";
        }
        if (message.valueArray != null && message.hasOwnProperty("valueArray")) {
            object.valueArray = options.bytes === String ? $util.base64.encode(message.valueArray, 0, message.valueArray.length) : options.bytes === Array ? Array.prototype.slice.call(message.valueArray) : message.valueArray;
            if (options.oneofs)
                object.data = "valueArray";
        }
        return object;
    };

    /**
     * Converts this ValueListInsertMessage to JSON.
     * @function toJSON
     * @memberof ValueListInsertMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ValueListInsertMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ValueListInsertMessage;
})();

export const ValueListMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of a ValueListMessage.
     * @exports IValueListMessage
     * @interface IValueListMessage
     * @property {IValueListInsertMessage|null} [insert] ValueListMessage insert
     * @property {string|null} ["delete"] ValueListMessage delete
     */

    /**
     * Constructs a new ValueListMessage.
     * @exports ValueListMessage
     * @classdesc Represents a ValueListMessage.
     * @implements IValueListMessage
     * @constructor
     * @param {IValueListMessage=} [properties] Properties to set
     */
    function ValueListMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ValueListMessage insert.
     * @member {IValueListInsertMessage|null|undefined} insert
     * @memberof ValueListMessage
     * @instance
     */
    ValueListMessage.prototype.insert = null;

    /**
     * ValueListMessage delete.
     * @member {string} delete
     * @memberof ValueListMessage
     * @instance
     */
    ValueListMessage.prototype["delete"] = "";

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * ValueListMessage op.
     * @member {"insert"|"delete"|undefined} op
     * @memberof ValueListMessage
     * @instance
     */
    Object.defineProperty(ValueListMessage.prototype, "op", {
        get: $util.oneOfGetter($oneOfFields = ["insert", "delete"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new ValueListMessage instance using the specified properties.
     * @function create
     * @memberof ValueListMessage
     * @static
     * @param {IValueListMessage=} [properties] Properties to set
     * @returns {ValueListMessage} ValueListMessage instance
     */
    ValueListMessage.create = function create(properties) {
        return new ValueListMessage(properties);
    };

    /**
     * Encodes the specified ValueListMessage message. Does not implicitly {@link ValueListMessage.verify|verify} messages.
     * @function encode
     * @memberof ValueListMessage
     * @static
     * @param {IValueListMessage} message ValueListMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ValueListMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.insert != null && Object.hasOwnProperty.call(message, "insert"))
            ValueListInsertMessage.encode(message.insert, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message["delete"] != null && Object.hasOwnProperty.call(message, "delete"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message["delete"]);
        return writer;
    };

    /**
     * Encodes the specified ValueListMessage message, length delimited. Does not implicitly {@link ValueListMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ValueListMessage
     * @static
     * @param {IValueListMessage} message ValueListMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ValueListMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ValueListMessage message from the specified reader or buffer.
     * @function decode
     * @memberof ValueListMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ValueListMessage} ValueListMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ValueListMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new ValueListMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.insert = ValueListInsertMessage.decode(reader, reader.uint32());
                break;
            case 2:
                message["delete"] = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ValueListMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ValueListMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ValueListMessage} ValueListMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ValueListMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ValueListMessage message.
     * @function verify
     * @memberof ValueListMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ValueListMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        let properties = {};
        if (message.insert != null && message.hasOwnProperty("insert")) {
            properties.op = 1;
            {
                let error = ValueListInsertMessage.verify(message.insert);
                if (error)
                    return "insert." + error;
            }
        }
        if (message["delete"] != null && message.hasOwnProperty("delete")) {
            if (properties.op === 1)
                return "op: multiple values";
            properties.op = 1;
            if (!$util.isString(message["delete"]))
                return "delete: string expected";
        }
        return null;
    };

    /**
     * Creates a ValueListMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ValueListMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ValueListMessage} ValueListMessage
     */
    ValueListMessage.fromObject = function fromObject(object) {
        if (object instanceof ValueListMessage)
            return object;
        let message = new ValueListMessage();
        if (object.insert != null) {
            if (typeof object.insert !== "object")
                throw TypeError(".ValueListMessage.insert: object expected");
            message.insert = ValueListInsertMessage.fromObject(object.insert);
        }
        if (object["delete"] != null)
            message["delete"] = String(object["delete"]);
        return message;
    };

    /**
     * Creates a plain object from a ValueListMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ValueListMessage
     * @static
     * @param {ValueListMessage} message ValueListMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ValueListMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (message.insert != null && message.hasOwnProperty("insert")) {
            object.insert = ValueListInsertMessage.toObject(message.insert, options);
            if (options.oneofs)
                object.op = "insert";
        }
        if (message["delete"] != null && message.hasOwnProperty("delete")) {
            object["delete"] = message["delete"];
            if (options.oneofs)
                object.op = "delete";
        }
        return object;
    };

    /**
     * Converts this ValueListMessage to JSON.
     * @function toJSON
     * @memberof ValueListMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ValueListMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ValueListMessage;
})();

export const LocalListSave = /*@__PURE__*/ (() => {

    /**
     * Properties of a LocalListSave.
     * @exports ILocalListSave
     * @interface ILocalListSave
     * @property {Array.<string>|null} [replicaIDs] LocalListSave replicaIDs
     * @property {Array.<number>|null} [replicaIDIndices] LocalListSave replicaIDIndices
     * @property {Array.<number>|null} [counters] LocalListSave counters
     * @property {Array.<number>|null} [totals] LocalListSave totals
     * @property {Array.<number>|null} [seens] LocalListSave seens
     * @property {Array.<number>|null} [itemsLengths] LocalListSave itemsLengths
     * @property {Array.<number>|null} [itemSizes] LocalListSave itemSizes
     * @property {Uint8Array} values LocalListSave values
     */

    /**
     * Constructs a new LocalListSave.
     * @exports LocalListSave
     * @classdesc Represents a LocalListSave.
     * @implements ILocalListSave
     * @constructor
     * @param {ILocalListSave=} [properties] Properties to set
     */
    function LocalListSave(properties) {
        this.replicaIDs = [];
        this.replicaIDIndices = [];
        this.counters = [];
        this.totals = [];
        this.seens = [];
        this.itemsLengths = [];
        this.itemSizes = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LocalListSave replicaIDs.
     * @member {Array.<string>} replicaIDs
     * @memberof LocalListSave
     * @instance
     */
    LocalListSave.prototype.replicaIDs = $util.emptyArray;

    /**
     * LocalListSave replicaIDIndices.
     * @member {Array.<number>} replicaIDIndices
     * @memberof LocalListSave
     * @instance
     */
    LocalListSave.prototype.replicaIDIndices = $util.emptyArray;

    /**
     * LocalListSave counters.
     * @member {Array.<number>} counters
     * @memberof LocalListSave
     * @instance
     */
    LocalListSave.prototype.counters = $util.emptyArray;

    /**
     * LocalListSave totals.
     * @member {Array.<number>} totals
     * @memberof LocalListSave
     * @instance
     */
    LocalListSave.prototype.totals = $util.emptyArray;

    /**
     * LocalListSave seens.
     * @member {Array.<number>} seens
     * @memberof LocalListSave
     * @instance
     */
    LocalListSave.prototype.seens = $util.emptyArray;

    /**
     * LocalListSave itemsLengths.
     * @member {Array.<number>} itemsLengths
     * @memberof LocalListSave
     * @instance
     */
    LocalListSave.prototype.itemsLengths = $util.emptyArray;

    /**
     * LocalListSave itemSizes.
     * @member {Array.<number>} itemSizes
     * @memberof LocalListSave
     * @instance
     */
    LocalListSave.prototype.itemSizes = $util.emptyArray;

    /**
     * LocalListSave values.
     * @member {Uint8Array} values
     * @memberof LocalListSave
     * @instance
     */
    LocalListSave.prototype.values = $util.newBuffer([]);

    /**
     * Creates a new LocalListSave instance using the specified properties.
     * @function create
     * @memberof LocalListSave
     * @static
     * @param {ILocalListSave=} [properties] Properties to set
     * @returns {LocalListSave} LocalListSave instance
     */
    LocalListSave.create = function create(properties) {
        return new LocalListSave(properties);
    };

    /**
     * Encodes the specified LocalListSave message. Does not implicitly {@link LocalListSave.verify|verify} messages.
     * @function encode
     * @memberof LocalListSave
     * @static
     * @param {ILocalListSave} message LocalListSave message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LocalListSave.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.replicaIDs != null && message.replicaIDs.length)
            for (let i = 0; i < message.replicaIDs.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.replicaIDs[i]);
        if (message.replicaIDIndices != null && message.replicaIDIndices.length) {
            writer.uint32(/* id 2, wireType 2 =*/18).fork();
            for (let i = 0; i < message.replicaIDIndices.length; ++i)
                writer.uint32(message.replicaIDIndices[i]);
            writer.ldelim();
        }
        if (message.counters != null && message.counters.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.counters.length; ++i)
                writer.uint32(message.counters[i]);
            writer.ldelim();
        }
        if (message.totals != null && message.totals.length) {
            writer.uint32(/* id 4, wireType 2 =*/34).fork();
            for (let i = 0; i < message.totals.length; ++i)
                writer.uint32(message.totals[i]);
            writer.ldelim();
        }
        if (message.seens != null && message.seens.length) {
            writer.uint32(/* id 5, wireType 2 =*/42).fork();
            for (let i = 0; i < message.seens.length; ++i)
                writer.uint32(message.seens[i]);
            writer.ldelim();
        }
        if (message.itemsLengths != null && message.itemsLengths.length) {
            writer.uint32(/* id 6, wireType 2 =*/50).fork();
            for (let i = 0; i < message.itemsLengths.length; ++i)
                writer.uint32(message.itemsLengths[i]);
            writer.ldelim();
        }
        if (message.itemSizes != null && message.itemSizes.length) {
            writer.uint32(/* id 7, wireType 2 =*/58).fork();
            for (let i = 0; i < message.itemSizes.length; ++i)
                writer.sint32(message.itemSizes[i]);
            writer.ldelim();
        }
        writer.uint32(/* id 8, wireType 2 =*/66).bytes(message.values);
        return writer;
    };

    /**
     * Encodes the specified LocalListSave message, length delimited. Does not implicitly {@link LocalListSave.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LocalListSave
     * @static
     * @param {ILocalListSave} message LocalListSave message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LocalListSave.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LocalListSave message from the specified reader or buffer.
     * @function decode
     * @memberof LocalListSave
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LocalListSave} LocalListSave
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LocalListSave.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new LocalListSave();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.replicaIDs && message.replicaIDs.length))
                    message.replicaIDs = [];
                message.replicaIDs.push(reader.string());
                break;
            case 2:
                if (!(message.replicaIDIndices && message.replicaIDIndices.length))
                    message.replicaIDIndices = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.replicaIDIndices.push(reader.uint32());
                } else
                    message.replicaIDIndices.push(reader.uint32());
                break;
            case 3:
                if (!(message.counters && message.counters.length))
                    message.counters = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.counters.push(reader.uint32());
                } else
                    message.counters.push(reader.uint32());
                break;
            case 4:
                if (!(message.totals && message.totals.length))
                    message.totals = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.totals.push(reader.uint32());
                } else
                    message.totals.push(reader.uint32());
                break;
            case 5:
                if (!(message.seens && message.seens.length))
                    message.seens = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.seens.push(reader.uint32());
                } else
                    message.seens.push(reader.uint32());
                break;
            case 6:
                if (!(message.itemsLengths && message.itemsLengths.length))
                    message.itemsLengths = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.itemsLengths.push(reader.uint32());
                } else
                    message.itemsLengths.push(reader.uint32());
                break;
            case 7:
                if (!(message.itemSizes && message.itemSizes.length))
                    message.itemSizes = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.itemSizes.push(reader.sint32());
                } else
                    message.itemSizes.push(reader.sint32());
                break;
            case 8:
                message.values = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("values"))
            throw $util.ProtocolError("missing required 'values'", { instance: message });
        return message;
    };

    /**
     * Decodes a LocalListSave message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LocalListSave
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LocalListSave} LocalListSave
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LocalListSave.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LocalListSave message.
     * @function verify
     * @memberof LocalListSave
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LocalListSave.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.replicaIDs != null && message.hasOwnProperty("replicaIDs")) {
            if (!Array.isArray(message.replicaIDs))
                return "replicaIDs: array expected";
            for (let i = 0; i < message.replicaIDs.length; ++i)
                if (!$util.isString(message.replicaIDs[i]))
                    return "replicaIDs: string[] expected";
        }
        if (message.replicaIDIndices != null && message.hasOwnProperty("replicaIDIndices")) {
            if (!Array.isArray(message.replicaIDIndices))
                return "replicaIDIndices: array expected";
            for (let i = 0; i < message.replicaIDIndices.length; ++i)
                if (!$util.isInteger(message.replicaIDIndices[i]))
                    return "replicaIDIndices: integer[] expected";
        }
        if (message.counters != null && message.hasOwnProperty("counters")) {
            if (!Array.isArray(message.counters))
                return "counters: array expected";
            for (let i = 0; i < message.counters.length; ++i)
                if (!$util.isInteger(message.counters[i]))
                    return "counters: integer[] expected";
        }
        if (message.totals != null && message.hasOwnProperty("totals")) {
            if (!Array.isArray(message.totals))
                return "totals: array expected";
            for (let i = 0; i < message.totals.length; ++i)
                if (!$util.isInteger(message.totals[i]))
                    return "totals: integer[] expected";
        }
        if (message.seens != null && message.hasOwnProperty("seens")) {
            if (!Array.isArray(message.seens))
                return "seens: array expected";
            for (let i = 0; i < message.seens.length; ++i)
                if (!$util.isInteger(message.seens[i]))
                    return "seens: integer[] expected";
        }
        if (message.itemsLengths != null && message.hasOwnProperty("itemsLengths")) {
            if (!Array.isArray(message.itemsLengths))
                return "itemsLengths: array expected";
            for (let i = 0; i < message.itemsLengths.length; ++i)
                if (!$util.isInteger(message.itemsLengths[i]))
                    return "itemsLengths: integer[] expected";
        }
        if (message.itemSizes != null && message.hasOwnProperty("itemSizes")) {
            if (!Array.isArray(message.itemSizes))
                return "itemSizes: array expected";
            for (let i = 0; i < message.itemSizes.length; ++i)
                if (!$util.isInteger(message.itemSizes[i]))
                    return "itemSizes: integer[] expected";
        }
        if (!(message.values && typeof message.values.length === "number" || $util.isString(message.values)))
            return "values: buffer expected";
        return null;
    };

    /**
     * Creates a LocalListSave message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LocalListSave
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LocalListSave} LocalListSave
     */
    LocalListSave.fromObject = function fromObject(object) {
        if (object instanceof LocalListSave)
            return object;
        let message = new LocalListSave();
        if (object.replicaIDs) {
            if (!Array.isArray(object.replicaIDs))
                throw TypeError(".LocalListSave.replicaIDs: array expected");
            message.replicaIDs = [];
            for (let i = 0; i < object.replicaIDs.length; ++i)
                message.replicaIDs[i] = String(object.replicaIDs[i]);
        }
        if (object.replicaIDIndices) {
            if (!Array.isArray(object.replicaIDIndices))
                throw TypeError(".LocalListSave.replicaIDIndices: array expected");
            message.replicaIDIndices = [];
            for (let i = 0; i < object.replicaIDIndices.length; ++i)
                message.replicaIDIndices[i] = object.replicaIDIndices[i] >>> 0;
        }
        if (object.counters) {
            if (!Array.isArray(object.counters))
                throw TypeError(".LocalListSave.counters: array expected");
            message.counters = [];
            for (let i = 0; i < object.counters.length; ++i)
                message.counters[i] = object.counters[i] >>> 0;
        }
        if (object.totals) {
            if (!Array.isArray(object.totals))
                throw TypeError(".LocalListSave.totals: array expected");
            message.totals = [];
            for (let i = 0; i < object.totals.length; ++i)
                message.totals[i] = object.totals[i] >>> 0;
        }
        if (object.seens) {
            if (!Array.isArray(object.seens))
                throw TypeError(".LocalListSave.seens: array expected");
            message.seens = [];
            for (let i = 0; i < object.seens.length; ++i)
                message.seens[i] = object.seens[i] >>> 0;
        }
        if (object.itemsLengths) {
            if (!Array.isArray(object.itemsLengths))
                throw TypeError(".LocalListSave.itemsLengths: array expected");
            message.itemsLengths = [];
            for (let i = 0; i < object.itemsLengths.length; ++i)
                message.itemsLengths[i] = object.itemsLengths[i] >>> 0;
        }
        if (object.itemSizes) {
            if (!Array.isArray(object.itemSizes))
                throw TypeError(".LocalListSave.itemSizes: array expected");
            message.itemSizes = [];
            for (let i = 0; i < object.itemSizes.length; ++i)
                message.itemSizes[i] = object.itemSizes[i] | 0;
        }
        if (object.values != null)
            if (typeof object.values === "string")
                $util.base64.decode(object.values, message.values = $util.newBuffer($util.base64.length(object.values)), 0);
            else if (object.values.length)
                message.values = object.values;
        return message;
    };

    /**
     * Creates a plain object from a LocalListSave message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LocalListSave
     * @static
     * @param {LocalListSave} message LocalListSave
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LocalListSave.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.replicaIDs = [];
            object.replicaIDIndices = [];
            object.counters = [];
            object.totals = [];
            object.seens = [];
            object.itemsLengths = [];
            object.itemSizes = [];
        }
        if (options.defaults)
            if (options.bytes === String)
                object.values = "";
            else {
                object.values = [];
                if (options.bytes !== Array)
                    object.values = $util.newBuffer(object.values);
            }
        if (message.replicaIDs && message.replicaIDs.length) {
            object.replicaIDs = [];
            for (let j = 0; j < message.replicaIDs.length; ++j)
                object.replicaIDs[j] = message.replicaIDs[j];
        }
        if (message.replicaIDIndices && message.replicaIDIndices.length) {
            object.replicaIDIndices = [];
            for (let j = 0; j < message.replicaIDIndices.length; ++j)
                object.replicaIDIndices[j] = message.replicaIDIndices[j];
        }
        if (message.counters && message.counters.length) {
            object.counters = [];
            for (let j = 0; j < message.counters.length; ++j)
                object.counters[j] = message.counters[j];
        }
        if (message.totals && message.totals.length) {
            object.totals = [];
            for (let j = 0; j < message.totals.length; ++j)
                object.totals[j] = message.totals[j];
        }
        if (message.seens && message.seens.length) {
            object.seens = [];
            for (let j = 0; j < message.seens.length; ++j)
                object.seens[j] = message.seens[j];
        }
        if (message.itemsLengths && message.itemsLengths.length) {
            object.itemsLengths = [];
            for (let j = 0; j < message.itemsLengths.length; ++j)
                object.itemsLengths[j] = message.itemsLengths[j];
        }
        if (message.itemSizes && message.itemSizes.length) {
            object.itemSizes = [];
            for (let j = 0; j < message.itemSizes.length; ++j)
                object.itemSizes[j] = message.itemSizes[j];
        }
        if (message.values != null && message.hasOwnProperty("values"))
            object.values = options.bytes === String ? $util.base64.encode(message.values, 0, message.values.length) : options.bytes === Array ? Array.prototype.slice.call(message.values) : message.values;
        return object;
    };

    /**
     * Converts this LocalListSave to JSON.
     * @function toJSON
     * @memberof LocalListSave
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LocalListSave.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LocalListSave;
})();

export const MultiValueMapMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of a MultiValueMapMessage.
     * @exports IMultiValueMapMessage
     * @interface IMultiValueMapMessage
     * @property {Uint8Array} key MultiValueMapMessage key
     * @property {Uint8Array|null} [value] MultiValueMapMessage value
     */

    /**
     * Constructs a new MultiValueMapMessage.
     * @exports MultiValueMapMessage
     * @classdesc Represents a MultiValueMapMessage.
     * @implements IMultiValueMapMessage
     * @constructor
     * @param {IMultiValueMapMessage=} [properties] Properties to set
     */
    function MultiValueMapMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MultiValueMapMessage key.
     * @member {Uint8Array} key
     * @memberof MultiValueMapMessage
     * @instance
     */
    MultiValueMapMessage.prototype.key = $util.newBuffer([]);

    /**
     * MultiValueMapMessage value.
     * @member {Uint8Array} value
     * @memberof MultiValueMapMessage
     * @instance
     */
    MultiValueMapMessage.prototype.value = $util.newBuffer([]);

    /**
     * Creates a new MultiValueMapMessage instance using the specified properties.
     * @function create
     * @memberof MultiValueMapMessage
     * @static
     * @param {IMultiValueMapMessage=} [properties] Properties to set
     * @returns {MultiValueMapMessage} MultiValueMapMessage instance
     */
    MultiValueMapMessage.create = function create(properties) {
        return new MultiValueMapMessage(properties);
    };

    /**
     * Encodes the specified MultiValueMapMessage message. Does not implicitly {@link MultiValueMapMessage.verify|verify} messages.
     * @function encode
     * @memberof MultiValueMapMessage
     * @static
     * @param {IMultiValueMapMessage} message MultiValueMapMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MultiValueMapMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.key);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.value);
        return writer;
    };

    /**
     * Encodes the specified MultiValueMapMessage message, length delimited. Does not implicitly {@link MultiValueMapMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MultiValueMapMessage
     * @static
     * @param {IMultiValueMapMessage} message MultiValueMapMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MultiValueMapMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MultiValueMapMessage message from the specified reader or buffer.
     * @function decode
     * @memberof MultiValueMapMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MultiValueMapMessage} MultiValueMapMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MultiValueMapMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new MultiValueMapMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.key = reader.bytes();
                break;
            case 2:
                message.value = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("key"))
            throw $util.ProtocolError("missing required 'key'", { instance: message });
        return message;
    };

    /**
     * Decodes a MultiValueMapMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MultiValueMapMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MultiValueMapMessage} MultiValueMapMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MultiValueMapMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MultiValueMapMessage message.
     * @function verify
     * @memberof MultiValueMapMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MultiValueMapMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.key && typeof message.key.length === "number" || $util.isString(message.key)))
            return "key: buffer expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                return "value: buffer expected";
        return null;
    };

    /**
     * Creates a MultiValueMapMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MultiValueMapMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MultiValueMapMessage} MultiValueMapMessage
     */
    MultiValueMapMessage.fromObject = function fromObject(object) {
        if (object instanceof MultiValueMapMessage)
            return object;
        let message = new MultiValueMapMessage();
        if (object.key != null)
            if (typeof object.key === "string")
                $util.base64.decode(object.key, message.key = $util.newBuffer($util.base64.length(object.key)), 0);
            else if (object.key.length)
                message.key = object.key;
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        return message;
    };

    /**
     * Creates a plain object from a MultiValueMapMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MultiValueMapMessage
     * @static
     * @param {MultiValueMapMessage} message MultiValueMapMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MultiValueMapMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.key = "";
            else {
                object.key = [];
                if (options.bytes !== Array)
                    object.key = $util.newBuffer(object.key);
            }
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
        }
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = options.bytes === String ? $util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        return object;
    };

    /**
     * Converts this MultiValueMapMessage to JSON.
     * @function toJSON
     * @memberof MultiValueMapMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MultiValueMapMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MultiValueMapMessage;
})();

export const MultiValueMapItemsSave = /*@__PURE__*/ (() => {

    /**
     * Properties of a MultiValueMapItemsSave.
     * @exports IMultiValueMapItemsSave
     * @interface IMultiValueMapItemsSave
     * @property {Array.<Uint8Array>|null} [values] MultiValueMapItemsSave values
     * @property {Array.<number>|null} [senders] MultiValueMapItemsSave senders
     * @property {Array.<number>|null} [senderCounters] MultiValueMapItemsSave senderCounters
     * @property {Array.<number|Long>|null} [wallClockTimes] MultiValueMapItemsSave wallClockTimes
     * @property {Array.<number|Long>|null} [lamportTimestamps] MultiValueMapItemsSave lamportTimestamps
     */

    /**
     * Constructs a new MultiValueMapItemsSave.
     * @exports MultiValueMapItemsSave
     * @classdesc Represents a MultiValueMapItemsSave.
     * @implements IMultiValueMapItemsSave
     * @constructor
     * @param {IMultiValueMapItemsSave=} [properties] Properties to set
     */
    function MultiValueMapItemsSave(properties) {
        this.values = [];
        this.senders = [];
        this.senderCounters = [];
        this.wallClockTimes = [];
        this.lamportTimestamps = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MultiValueMapItemsSave values.
     * @member {Array.<Uint8Array>} values
     * @memberof MultiValueMapItemsSave
     * @instance
     */
    MultiValueMapItemsSave.prototype.values = $util.emptyArray;

    /**
     * MultiValueMapItemsSave senders.
     * @member {Array.<number>} senders
     * @memberof MultiValueMapItemsSave
     * @instance
     */
    MultiValueMapItemsSave.prototype.senders = $util.emptyArray;

    /**
     * MultiValueMapItemsSave senderCounters.
     * @member {Array.<number>} senderCounters
     * @memberof MultiValueMapItemsSave
     * @instance
     */
    MultiValueMapItemsSave.prototype.senderCounters = $util.emptyArray;

    /**
     * MultiValueMapItemsSave wallClockTimes.
     * @member {Array.<number|Long>} wallClockTimes
     * @memberof MultiValueMapItemsSave
     * @instance
     */
    MultiValueMapItemsSave.prototype.wallClockTimes = $util.emptyArray;

    /**
     * MultiValueMapItemsSave lamportTimestamps.
     * @member {Array.<number|Long>} lamportTimestamps
     * @memberof MultiValueMapItemsSave
     * @instance
     */
    MultiValueMapItemsSave.prototype.lamportTimestamps = $util.emptyArray;

    /**
     * Creates a new MultiValueMapItemsSave instance using the specified properties.
     * @function create
     * @memberof MultiValueMapItemsSave
     * @static
     * @param {IMultiValueMapItemsSave=} [properties] Properties to set
     * @returns {MultiValueMapItemsSave} MultiValueMapItemsSave instance
     */
    MultiValueMapItemsSave.create = function create(properties) {
        return new MultiValueMapItemsSave(properties);
    };

    /**
     * Encodes the specified MultiValueMapItemsSave message. Does not implicitly {@link MultiValueMapItemsSave.verify|verify} messages.
     * @function encode
     * @memberof MultiValueMapItemsSave
     * @static
     * @param {IMultiValueMapItemsSave} message MultiValueMapItemsSave message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MultiValueMapItemsSave.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.values != null && message.values.length)
            for (let i = 0; i < message.values.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.values[i]);
        if (message.senders != null && message.senders.length) {
            writer.uint32(/* id 2, wireType 2 =*/18).fork();
            for (let i = 0; i < message.senders.length; ++i)
                writer.uint32(message.senders[i]);
            writer.ldelim();
        }
        if (message.senderCounters != null && message.senderCounters.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.senderCounters.length; ++i)
                writer.uint32(message.senderCounters[i]);
            writer.ldelim();
        }
        if (message.wallClockTimes != null && message.wallClockTimes.length) {
            writer.uint32(/* id 4, wireType 2 =*/34).fork();
            for (let i = 0; i < message.wallClockTimes.length; ++i)
                writer.uint64(message.wallClockTimes[i]);
            writer.ldelim();
        }
        if (message.lamportTimestamps != null && message.lamportTimestamps.length) {
            writer.uint32(/* id 5, wireType 2 =*/42).fork();
            for (let i = 0; i < message.lamportTimestamps.length; ++i)
                writer.uint64(message.lamportTimestamps[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified MultiValueMapItemsSave message, length delimited. Does not implicitly {@link MultiValueMapItemsSave.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MultiValueMapItemsSave
     * @static
     * @param {IMultiValueMapItemsSave} message MultiValueMapItemsSave message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MultiValueMapItemsSave.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MultiValueMapItemsSave message from the specified reader or buffer.
     * @function decode
     * @memberof MultiValueMapItemsSave
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MultiValueMapItemsSave} MultiValueMapItemsSave
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MultiValueMapItemsSave.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new MultiValueMapItemsSave();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.values && message.values.length))
                    message.values = [];
                message.values.push(reader.bytes());
                break;
            case 2:
                if (!(message.senders && message.senders.length))
                    message.senders = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.senders.push(reader.uint32());
                } else
                    message.senders.push(reader.uint32());
                break;
            case 3:
                if (!(message.senderCounters && message.senderCounters.length))
                    message.senderCounters = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.senderCounters.push(reader.uint32());
                } else
                    message.senderCounters.push(reader.uint32());
                break;
            case 4:
                if (!(message.wallClockTimes && message.wallClockTimes.length))
                    message.wallClockTimes = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.wallClockTimes.push(reader.uint64());
                } else
                    message.wallClockTimes.push(reader.uint64());
                break;
            case 5:
                if (!(message.lamportTimestamps && message.lamportTimestamps.length))
                    message.lamportTimestamps = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.lamportTimestamps.push(reader.uint64());
                } else
                    message.lamportTimestamps.push(reader.uint64());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MultiValueMapItemsSave message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MultiValueMapItemsSave
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MultiValueMapItemsSave} MultiValueMapItemsSave
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MultiValueMapItemsSave.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MultiValueMapItemsSave message.
     * @function verify
     * @memberof MultiValueMapItemsSave
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MultiValueMapItemsSave.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.values != null && message.hasOwnProperty("values")) {
            if (!Array.isArray(message.values))
                return "values: array expected";
            for (let i = 0; i < message.values.length; ++i)
                if (!(message.values[i] && typeof message.values[i].length === "number" || $util.isString(message.values[i])))
                    return "values: buffer[] expected";
        }
        if (message.senders != null && message.hasOwnProperty("senders")) {
            if (!Array.isArray(message.senders))
                return "senders: array expected";
            for (let i = 0; i < message.senders.length; ++i)
                if (!$util.isInteger(message.senders[i]))
                    return "senders: integer[] expected";
        }
        if (message.senderCounters != null && message.hasOwnProperty("senderCounters")) {
            if (!Array.isArray(message.senderCounters))
                return "senderCounters: array expected";
            for (let i = 0; i < message.senderCounters.length; ++i)
                if (!$util.isInteger(message.senderCounters[i]))
                    return "senderCounters: integer[] expected";
        }
        if (message.wallClockTimes != null && message.hasOwnProperty("wallClockTimes")) {
            if (!Array.isArray(message.wallClockTimes))
                return "wallClockTimes: array expected";
            for (let i = 0; i < message.wallClockTimes.length; ++i)
                if (!$util.isInteger(message.wallClockTimes[i]) && !(message.wallClockTimes[i] && $util.isInteger(message.wallClockTimes[i].low) && $util.isInteger(message.wallClockTimes[i].high)))
                    return "wallClockTimes: integer|Long[] expected";
        }
        if (message.lamportTimestamps != null && message.hasOwnProperty("lamportTimestamps")) {
            if (!Array.isArray(message.lamportTimestamps))
                return "lamportTimestamps: array expected";
            for (let i = 0; i < message.lamportTimestamps.length; ++i)
                if (!$util.isInteger(message.lamportTimestamps[i]) && !(message.lamportTimestamps[i] && $util.isInteger(message.lamportTimestamps[i].low) && $util.isInteger(message.lamportTimestamps[i].high)))
                    return "lamportTimestamps: integer|Long[] expected";
        }
        return null;
    };

    /**
     * Creates a MultiValueMapItemsSave message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MultiValueMapItemsSave
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MultiValueMapItemsSave} MultiValueMapItemsSave
     */
    MultiValueMapItemsSave.fromObject = function fromObject(object) {
        if (object instanceof MultiValueMapItemsSave)
            return object;
        let message = new MultiValueMapItemsSave();
        if (object.values) {
            if (!Array.isArray(object.values))
                throw TypeError(".MultiValueMapItemsSave.values: array expected");
            message.values = [];
            for (let i = 0; i < object.values.length; ++i)
                if (typeof object.values[i] === "string")
                    $util.base64.decode(object.values[i], message.values[i] = $util.newBuffer($util.base64.length(object.values[i])), 0);
                else if (object.values[i].length)
                    message.values[i] = object.values[i];
        }
        if (object.senders) {
            if (!Array.isArray(object.senders))
                throw TypeError(".MultiValueMapItemsSave.senders: array expected");
            message.senders = [];
            for (let i = 0; i < object.senders.length; ++i)
                message.senders[i] = object.senders[i] >>> 0;
        }
        if (object.senderCounters) {
            if (!Array.isArray(object.senderCounters))
                throw TypeError(".MultiValueMapItemsSave.senderCounters: array expected");
            message.senderCounters = [];
            for (let i = 0; i < object.senderCounters.length; ++i)
                message.senderCounters[i] = object.senderCounters[i] >>> 0;
        }
        if (object.wallClockTimes) {
            if (!Array.isArray(object.wallClockTimes))
                throw TypeError(".MultiValueMapItemsSave.wallClockTimes: array expected");
            message.wallClockTimes = [];
            for (let i = 0; i < object.wallClockTimes.length; ++i)
                if ($util.Long)
                    (message.wallClockTimes[i] = $util.Long.fromValue(object.wallClockTimes[i])).unsigned = true;
                else if (typeof object.wallClockTimes[i] === "string")
                    message.wallClockTimes[i] = parseInt(object.wallClockTimes[i], 10);
                else if (typeof object.wallClockTimes[i] === "number")
                    message.wallClockTimes[i] = object.wallClockTimes[i];
                else if (typeof object.wallClockTimes[i] === "object")
                    message.wallClockTimes[i] = new $util.LongBits(object.wallClockTimes[i].low >>> 0, object.wallClockTimes[i].high >>> 0).toNumber(true);
        }
        if (object.lamportTimestamps) {
            if (!Array.isArray(object.lamportTimestamps))
                throw TypeError(".MultiValueMapItemsSave.lamportTimestamps: array expected");
            message.lamportTimestamps = [];
            for (let i = 0; i < object.lamportTimestamps.length; ++i)
                if ($util.Long)
                    (message.lamportTimestamps[i] = $util.Long.fromValue(object.lamportTimestamps[i])).unsigned = true;
                else if (typeof object.lamportTimestamps[i] === "string")
                    message.lamportTimestamps[i] = parseInt(object.lamportTimestamps[i], 10);
                else if (typeof object.lamportTimestamps[i] === "number")
                    message.lamportTimestamps[i] = object.lamportTimestamps[i];
                else if (typeof object.lamportTimestamps[i] === "object")
                    message.lamportTimestamps[i] = new $util.LongBits(object.lamportTimestamps[i].low >>> 0, object.lamportTimestamps[i].high >>> 0).toNumber(true);
        }
        return message;
    };

    /**
     * Creates a plain object from a MultiValueMapItemsSave message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MultiValueMapItemsSave
     * @static
     * @param {MultiValueMapItemsSave} message MultiValueMapItemsSave
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MultiValueMapItemsSave.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.values = [];
            object.senders = [];
            object.senderCounters = [];
            object.wallClockTimes = [];
            object.lamportTimestamps = [];
        }
        if (message.values && message.values.length) {
            object.values = [];
            for (let j = 0; j < message.values.length; ++j)
                object.values[j] = options.bytes === String ? $util.base64.encode(message.values[j], 0, message.values[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.values[j]) : message.values[j];
        }
        if (message.senders && message.senders.length) {
            object.senders = [];
            for (let j = 0; j < message.senders.length; ++j)
                object.senders[j] = message.senders[j];
        }
        if (message.senderCounters && message.senderCounters.length) {
            object.senderCounters = [];
            for (let j = 0; j < message.senderCounters.length; ++j)
                object.senderCounters[j] = message.senderCounters[j];
        }
        if (message.wallClockTimes && message.wallClockTimes.length) {
            object.wallClockTimes = [];
            for (let j = 0; j < message.wallClockTimes.length; ++j)
                if (typeof message.wallClockTimes[j] === "number")
                    object.wallClockTimes[j] = options.longs === String ? String(message.wallClockTimes[j]) : message.wallClockTimes[j];
                else
                    object.wallClockTimes[j] = options.longs === String ? $util.Long.prototype.toString.call(message.wallClockTimes[j]) : options.longs === Number ? new $util.LongBits(message.wallClockTimes[j].low >>> 0, message.wallClockTimes[j].high >>> 0).toNumber(true) : message.wallClockTimes[j];
        }
        if (message.lamportTimestamps && message.lamportTimestamps.length) {
            object.lamportTimestamps = [];
            for (let j = 0; j < message.lamportTimestamps.length; ++j)
                if (typeof message.lamportTimestamps[j] === "number")
                    object.lamportTimestamps[j] = options.longs === String ? String(message.lamportTimestamps[j]) : message.lamportTimestamps[j];
                else
                    object.lamportTimestamps[j] = options.longs === String ? $util.Long.prototype.toString.call(message.lamportTimestamps[j]) : options.longs === Number ? new $util.LongBits(message.lamportTimestamps[j].low >>> 0, message.lamportTimestamps[j].high >>> 0).toNumber(true) : message.lamportTimestamps[j];
        }
        return object;
    };

    /**
     * Converts this MultiValueMapItemsSave to JSON.
     * @function toJSON
     * @memberof MultiValueMapItemsSave
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MultiValueMapItemsSave.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MultiValueMapItemsSave;
})();

export const MultiValueMapSave = /*@__PURE__*/ (() => {

    /**
     * Properties of a MultiValueMapSave.
     * @exports IMultiValueMapSave
     * @interface IMultiValueMapSave
     * @property {Object.<string,IMultiValueMapItemsSave>|null} [entries] MultiValueMapSave entries
     * @property {Array.<string>|null} [senders] MultiValueMapSave senders
     */

    /**
     * Constructs a new MultiValueMapSave.
     * @exports MultiValueMapSave
     * @classdesc Represents a MultiValueMapSave.
     * @implements IMultiValueMapSave
     * @constructor
     * @param {IMultiValueMapSave=} [properties] Properties to set
     */
    function MultiValueMapSave(properties) {
        this.entries = {};
        this.senders = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MultiValueMapSave entries.
     * @member {Object.<string,IMultiValueMapItemsSave>} entries
     * @memberof MultiValueMapSave
     * @instance
     */
    MultiValueMapSave.prototype.entries = $util.emptyObject;

    /**
     * MultiValueMapSave senders.
     * @member {Array.<string>} senders
     * @memberof MultiValueMapSave
     * @instance
     */
    MultiValueMapSave.prototype.senders = $util.emptyArray;

    /**
     * Creates a new MultiValueMapSave instance using the specified properties.
     * @function create
     * @memberof MultiValueMapSave
     * @static
     * @param {IMultiValueMapSave=} [properties] Properties to set
     * @returns {MultiValueMapSave} MultiValueMapSave instance
     */
    MultiValueMapSave.create = function create(properties) {
        return new MultiValueMapSave(properties);
    };

    /**
     * Encodes the specified MultiValueMapSave message. Does not implicitly {@link MultiValueMapSave.verify|verify} messages.
     * @function encode
     * @memberof MultiValueMapSave
     * @static
     * @param {IMultiValueMapSave} message MultiValueMapSave message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MultiValueMapSave.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.entries != null && Object.hasOwnProperty.call(message, "entries"))
            for (let keys = Object.keys(message.entries), i = 0; i < keys.length; ++i) {
                writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                MultiValueMapItemsSave.encode(message.entries[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
            }
        if (message.senders != null && message.senders.length)
            for (let i = 0; i < message.senders.length; ++i)
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.senders[i]);
        return writer;
    };

    /**
     * Encodes the specified MultiValueMapSave message, length delimited. Does not implicitly {@link MultiValueMapSave.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MultiValueMapSave
     * @static
     * @param {IMultiValueMapSave} message MultiValueMapSave message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MultiValueMapSave.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MultiValueMapSave message from the specified reader or buffer.
     * @function decode
     * @memberof MultiValueMapSave
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MultiValueMapSave} MultiValueMapSave
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MultiValueMapSave.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new MultiValueMapSave(), key;
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                reader.skip().pos++;
                if (message.entries === $util.emptyObject)
                    message.entries = {};
                key = reader.string();
                reader.pos++;
                message.entries[key] = MultiValueMapItemsSave.decode(reader, reader.uint32());
                break;
            case 2:
                if (!(message.senders && message.senders.length))
                    message.senders = [];
                message.senders.push(reader.string());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MultiValueMapSave message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MultiValueMapSave
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MultiValueMapSave} MultiValueMapSave
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MultiValueMapSave.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MultiValueMapSave message.
     * @function verify
     * @memberof MultiValueMapSave
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MultiValueMapSave.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.entries != null && message.hasOwnProperty("entries")) {
            if (!$util.isObject(message.entries))
                return "entries: object expected";
            let key = Object.keys(message.entries);
            for (let i = 0; i < key.length; ++i) {
                let error = MultiValueMapItemsSave.verify(message.entries[key[i]]);
                if (error)
                    return "entries." + error;
            }
        }
        if (message.senders != null && message.hasOwnProperty("senders")) {
            if (!Array.isArray(message.senders))
                return "senders: array expected";
            for (let i = 0; i < message.senders.length; ++i)
                if (!$util.isString(message.senders[i]))
                    return "senders: string[] expected";
        }
        return null;
    };

    /**
     * Creates a MultiValueMapSave message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MultiValueMapSave
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MultiValueMapSave} MultiValueMapSave
     */
    MultiValueMapSave.fromObject = function fromObject(object) {
        if (object instanceof MultiValueMapSave)
            return object;
        let message = new MultiValueMapSave();
        if (object.entries) {
            if (typeof object.entries !== "object")
                throw TypeError(".MultiValueMapSave.entries: object expected");
            message.entries = {};
            for (let keys = Object.keys(object.entries), i = 0; i < keys.length; ++i) {
                if (typeof object.entries[keys[i]] !== "object")
                    throw TypeError(".MultiValueMapSave.entries: object expected");
                message.entries[keys[i]] = MultiValueMapItemsSave.fromObject(object.entries[keys[i]]);
            }
        }
        if (object.senders) {
            if (!Array.isArray(object.senders))
                throw TypeError(".MultiValueMapSave.senders: array expected");
            message.senders = [];
            for (let i = 0; i < object.senders.length; ++i)
                message.senders[i] = String(object.senders[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a MultiValueMapSave message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MultiValueMapSave
     * @static
     * @param {MultiValueMapSave} message MultiValueMapSave
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MultiValueMapSave.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.senders = [];
        if (options.objects || options.defaults)
            object.entries = {};
        let keys2;
        if (message.entries && (keys2 = Object.keys(message.entries)).length) {
            object.entries = {};
            for (let j = 0; j < keys2.length; ++j)
                object.entries[keys2[j]] = MultiValueMapItemsSave.toObject(message.entries[keys2[j]], options);
        }
        if (message.senders && message.senders.length) {
            object.senders = [];
            for (let j = 0; j < message.senders.length; ++j)
                object.senders[j] = message.senders[j];
        }
        return object;
    };

    /**
     * Converts this MultiValueMapSave to JSON.
     * @function toJSON
     * @memberof MultiValueMapSave
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MultiValueMapSave.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MultiValueMapSave;
})();

export const PresenceSetMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of a PresenceSetMessage.
     * @exports IPresenceSetMessage
     * @interface IPresenceSetMessage
     * @property {Uint8Array} value PresenceSetMessage value
     * @property {boolean|null} [isJoin] PresenceSetMessage isJoin
     * @property {boolean|null} [isResponse] PresenceSetMessage isResponse
     */

    /**
     * Constructs a new PresenceSetMessage.
     * @exports PresenceSetMessage
     * @classdesc Represents a PresenceSetMessage.
     * @implements IPresenceSetMessage
     * @constructor
     * @param {IPresenceSetMessage=} [properties] Properties to set
     */
    function PresenceSetMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PresenceSetMessage value.
     * @member {Uint8Array} value
     * @memberof PresenceSetMessage
     * @instance
     */
    PresenceSetMessage.prototype.value = $util.newBuffer([]);

    /**
     * PresenceSetMessage isJoin.
     * @member {boolean} isJoin
     * @memberof PresenceSetMessage
     * @instance
     */
    PresenceSetMessage.prototype.isJoin = false;

    /**
     * PresenceSetMessage isResponse.
     * @member {boolean} isResponse
     * @memberof PresenceSetMessage
     * @instance
     */
    PresenceSetMessage.prototype.isResponse = false;

    /**
     * Creates a new PresenceSetMessage instance using the specified properties.
     * @function create
     * @memberof PresenceSetMessage
     * @static
     * @param {IPresenceSetMessage=} [properties] Properties to set
     * @returns {PresenceSetMessage} PresenceSetMessage instance
     */
    PresenceSetMessage.create = function create(properties) {
        return new PresenceSetMessage(properties);
    };

    /**
     * Encodes the specified PresenceSetMessage message. Does not implicitly {@link PresenceSetMessage.verify|verify} messages.
     * @function encode
     * @memberof PresenceSetMessage
     * @static
     * @param {IPresenceSetMessage} message PresenceSetMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PresenceSetMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.value);
        if (message.isJoin != null && Object.hasOwnProperty.call(message, "isJoin"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isJoin);
        if (message.isResponse != null && Object.hasOwnProperty.call(message, "isResponse"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isResponse);
        return writer;
    };

    /**
     * Encodes the specified PresenceSetMessage message, length delimited. Does not implicitly {@link PresenceSetMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PresenceSetMessage
     * @static
     * @param {IPresenceSetMessage} message PresenceSetMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PresenceSetMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PresenceSetMessage message from the specified reader or buffer.
     * @function decode
     * @memberof PresenceSetMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PresenceSetMessage} PresenceSetMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PresenceSetMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new PresenceSetMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.value = reader.bytes();
                break;
            case 2:
                message.isJoin = reader.bool();
                break;
            case 3:
                message.isResponse = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        return message;
    };

    /**
     * Decodes a PresenceSetMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PresenceSetMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PresenceSetMessage} PresenceSetMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PresenceSetMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PresenceSetMessage message.
     * @function verify
     * @memberof PresenceSetMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PresenceSetMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        if (message.isJoin != null && message.hasOwnProperty("isJoin"))
            if (typeof message.isJoin !== "boolean")
                return "isJoin: boolean expected";
        if (message.isResponse != null && message.hasOwnProperty("isResponse"))
            if (typeof message.isResponse !== "boolean")
                return "isResponse: boolean expected";
        return null;
    };

    /**
     * Creates a PresenceSetMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PresenceSetMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PresenceSetMessage} PresenceSetMessage
     */
    PresenceSetMessage.fromObject = function fromObject(object) {
        if (object instanceof PresenceSetMessage)
            return object;
        let message = new PresenceSetMessage();
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.isJoin != null)
            message.isJoin = Boolean(object.isJoin);
        if (object.isResponse != null)
            message.isResponse = Boolean(object.isResponse);
        return message;
    };

    /**
     * Creates a plain object from a PresenceSetMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PresenceSetMessage
     * @static
     * @param {PresenceSetMessage} message PresenceSetMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PresenceSetMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            object.isJoin = false;
            object.isResponse = false;
        }
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.isJoin != null && message.hasOwnProperty("isJoin"))
            object.isJoin = message.isJoin;
        if (message.isResponse != null && message.hasOwnProperty("isResponse"))
            object.isResponse = message.isResponse;
        return object;
    };

    /**
     * Converts this PresenceSetMessage to JSON.
     * @function toJSON
     * @memberof PresenceSetMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PresenceSetMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PresenceSetMessage;
})();

export const PresenceRequestMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of a PresenceRequestMessage.
     * @exports IPresenceRequestMessage
     * @interface IPresenceRequestMessage
     * @property {string} replicaID PresenceRequestMessage replicaID
     */

    /**
     * Constructs a new PresenceRequestMessage.
     * @exports PresenceRequestMessage
     * @classdesc Represents a PresenceRequestMessage.
     * @implements IPresenceRequestMessage
     * @constructor
     * @param {IPresenceRequestMessage=} [properties] Properties to set
     */
    function PresenceRequestMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PresenceRequestMessage replicaID.
     * @member {string} replicaID
     * @memberof PresenceRequestMessage
     * @instance
     */
    PresenceRequestMessage.prototype.replicaID = "";

    /**
     * Creates a new PresenceRequestMessage instance using the specified properties.
     * @function create
     * @memberof PresenceRequestMessage
     * @static
     * @param {IPresenceRequestMessage=} [properties] Properties to set
     * @returns {PresenceRequestMessage} PresenceRequestMessage instance
     */
    PresenceRequestMessage.create = function create(properties) {
        return new PresenceRequestMessage(properties);
    };

    /**
     * Encodes the specified PresenceRequestMessage message. Does not implicitly {@link PresenceRequestMessage.verify|verify} messages.
     * @function encode
     * @memberof PresenceRequestMessage
     * @static
     * @param {IPresenceRequestMessage} message PresenceRequestMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PresenceRequestMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.replicaID);
        return writer;
    };

    /**
     * Encodes the specified PresenceRequestMessage message, length delimited. Does not implicitly {@link PresenceRequestMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PresenceRequestMessage
     * @static
     * @param {IPresenceRequestMessage} message PresenceRequestMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PresenceRequestMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PresenceRequestMessage message from the specified reader or buffer.
     * @function decode
     * @memberof PresenceRequestMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PresenceRequestMessage} PresenceRequestMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PresenceRequestMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new PresenceRequestMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.replicaID = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("replicaID"))
            throw $util.ProtocolError("missing required 'replicaID'", { instance: message });
        return message;
    };

    /**
     * Decodes a PresenceRequestMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PresenceRequestMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PresenceRequestMessage} PresenceRequestMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PresenceRequestMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PresenceRequestMessage message.
     * @function verify
     * @memberof PresenceRequestMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PresenceRequestMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.replicaID))
            return "replicaID: string expected";
        return null;
    };

    /**
     * Creates a PresenceRequestMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PresenceRequestMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PresenceRequestMessage} PresenceRequestMessage
     */
    PresenceRequestMessage.fromObject = function fromObject(object) {
        if (object instanceof PresenceRequestMessage)
            return object;
        let message = new PresenceRequestMessage();
        if (object.replicaID != null)
            message.replicaID = String(object.replicaID);
        return message;
    };

    /**
     * Creates a plain object from a PresenceRequestMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PresenceRequestMessage
     * @static
     * @param {PresenceRequestMessage} message PresenceRequestMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PresenceRequestMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.replicaID = "";
        if (message.replicaID != null && message.hasOwnProperty("replicaID"))
            object.replicaID = message.replicaID;
        return object;
    };

    /**
     * Converts this PresenceRequestMessage to JSON.
     * @function toJSON
     * @memberof PresenceRequestMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PresenceRequestMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PresenceRequestMessage;
})();

export const PresenceMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of a PresenceMessage.
     * @exports IPresenceMessage
     * @interface IPresenceMessage
     * @property {boolean|null} [heartbeat] PresenceMessage heartbeat
     * @property {IPresenceSetMessage|null} [set] PresenceMessage set
     * @property {Uint8Array|null} [update] PresenceMessage update
     * @property {boolean|null} [disconnect] PresenceMessage disconnect
     * @property {string|null} [request] PresenceMessage request
     */

    /**
     * Constructs a new PresenceMessage.
     * @exports PresenceMessage
     * @classdesc Represents a PresenceMessage.
     * @implements IPresenceMessage
     * @constructor
     * @param {IPresenceMessage=} [properties] Properties to set
     */
    function PresenceMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PresenceMessage heartbeat.
     * @member {boolean} heartbeat
     * @memberof PresenceMessage
     * @instance
     */
    PresenceMessage.prototype.heartbeat = false;

    /**
     * PresenceMessage set.
     * @member {IPresenceSetMessage|null|undefined} set
     * @memberof PresenceMessage
     * @instance
     */
    PresenceMessage.prototype.set = null;

    /**
     * PresenceMessage update.
     * @member {Uint8Array} update
     * @memberof PresenceMessage
     * @instance
     */
    PresenceMessage.prototype.update = $util.newBuffer([]);

    /**
     * PresenceMessage disconnect.
     * @member {boolean} disconnect
     * @memberof PresenceMessage
     * @instance
     */
    PresenceMessage.prototype.disconnect = false;

    /**
     * PresenceMessage request.
     * @member {string} request
     * @memberof PresenceMessage
     * @instance
     */
    PresenceMessage.prototype.request = "";

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * PresenceMessage type.
     * @member {"heartbeat"|"set"|"update"|"disconnect"|"request"|undefined} type
     * @memberof PresenceMessage
     * @instance
     */
    Object.defineProperty(PresenceMessage.prototype, "type", {
        get: $util.oneOfGetter($oneOfFields = ["heartbeat", "set", "update", "disconnect", "request"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new PresenceMessage instance using the specified properties.
     * @function create
     * @memberof PresenceMessage
     * @static
     * @param {IPresenceMessage=} [properties] Properties to set
     * @returns {PresenceMessage} PresenceMessage instance
     */
    PresenceMessage.create = function create(properties) {
        return new PresenceMessage(properties);
    };

    /**
     * Encodes the specified PresenceMessage message. Does not implicitly {@link PresenceMessage.verify|verify} messages.
     * @function encode
     * @memberof PresenceMessage
     * @static
     * @param {IPresenceMessage} message PresenceMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PresenceMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.heartbeat != null && Object.hasOwnProperty.call(message, "heartbeat"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.heartbeat);
        if (message.set != null && Object.hasOwnProperty.call(message, "set"))
            PresenceSetMessage.encode(message.set, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.update != null && Object.hasOwnProperty.call(message, "update"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.update);
        if (message.disconnect != null && Object.hasOwnProperty.call(message, "disconnect"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.disconnect);
        if (message.request != null && Object.hasOwnProperty.call(message, "request"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.request);
        return writer;
    };

    /**
     * Encodes the specified PresenceMessage message, length delimited. Does not implicitly {@link PresenceMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PresenceMessage
     * @static
     * @param {IPresenceMessage} message PresenceMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PresenceMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PresenceMessage message from the specified reader or buffer.
     * @function decode
     * @memberof PresenceMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PresenceMessage} PresenceMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PresenceMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new PresenceMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.heartbeat = reader.bool();
                break;
            case 2:
                message.set = PresenceSetMessage.decode(reader, reader.uint32());
                break;
            case 3:
                message.update = reader.bytes();
                break;
            case 4:
                message.disconnect = reader.bool();
                break;
            case 5:
                message.request = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PresenceMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PresenceMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PresenceMessage} PresenceMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PresenceMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PresenceMessage message.
     * @function verify
     * @memberof PresenceMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PresenceMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        let properties = {};
        if (message.heartbeat != null && message.hasOwnProperty("heartbeat")) {
            properties.type = 1;
            if (typeof message.heartbeat !== "boolean")
                return "heartbeat: boolean expected";
        }
        if (message.set != null && message.hasOwnProperty("set")) {
            if (properties.type === 1)
                return "type: multiple values";
            properties.type = 1;
            {
                let error = PresenceSetMessage.verify(message.set);
                if (error)
                    return "set." + error;
            }
        }
        if (message.update != null && message.hasOwnProperty("update")) {
            if (properties.type === 1)
                return "type: multiple values";
            properties.type = 1;
            if (!(message.update && typeof message.update.length === "number" || $util.isString(message.update)))
                return "update: buffer expected";
        }
        if (message.disconnect != null && message.hasOwnProperty("disconnect")) {
            if (properties.type === 1)
                return "type: multiple values";
            properties.type = 1;
            if (typeof message.disconnect !== "boolean")
                return "disconnect: boolean expected";
        }
        if (message.request != null && message.hasOwnProperty("request")) {
            if (properties.type === 1)
                return "type: multiple values";
            properties.type = 1;
            if (!$util.isString(message.request))
                return "request: string expected";
        }
        return null;
    };

    /**
     * Creates a PresenceMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PresenceMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PresenceMessage} PresenceMessage
     */
    PresenceMessage.fromObject = function fromObject(object) {
        if (object instanceof PresenceMessage)
            return object;
        let message = new PresenceMessage();
        if (object.heartbeat != null)
            message.heartbeat = Boolean(object.heartbeat);
        if (object.set != null) {
            if (typeof object.set !== "object")
                throw TypeError(".PresenceMessage.set: object expected");
            message.set = PresenceSetMessage.fromObject(object.set);
        }
        if (object.update != null)
            if (typeof object.update === "string")
                $util.base64.decode(object.update, message.update = $util.newBuffer($util.base64.length(object.update)), 0);
            else if (object.update.length)
                message.update = object.update;
        if (object.disconnect != null)
            message.disconnect = Boolean(object.disconnect);
        if (object.request != null)
            message.request = String(object.request);
        return message;
    };

    /**
     * Creates a plain object from a PresenceMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PresenceMessage
     * @static
     * @param {PresenceMessage} message PresenceMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PresenceMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (message.heartbeat != null && message.hasOwnProperty("heartbeat")) {
            object.heartbeat = message.heartbeat;
            if (options.oneofs)
                object.type = "heartbeat";
        }
        if (message.set != null && message.hasOwnProperty("set")) {
            object.set = PresenceSetMessage.toObject(message.set, options);
            if (options.oneofs)
                object.type = "set";
        }
        if (message.update != null && message.hasOwnProperty("update")) {
            object.update = options.bytes === String ? $util.base64.encode(message.update, 0, message.update.length) : options.bytes === Array ? Array.prototype.slice.call(message.update) : message.update;
            if (options.oneofs)
                object.type = "update";
        }
        if (message.disconnect != null && message.hasOwnProperty("disconnect")) {
            object.disconnect = message.disconnect;
            if (options.oneofs)
                object.type = "disconnect";
        }
        if (message.request != null && message.hasOwnProperty("request")) {
            object.request = message.request;
            if (options.oneofs)
                object.type = "request";
        }
        return object;
    };

    /**
     * Converts this PresenceMessage to JSON.
     * @function toJSON
     * @memberof PresenceMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PresenceMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PresenceMessage;
})();

export const PresenceInfoSave = /*@__PURE__*/ (() => {

    /**
     * Properties of a PresenceInfoSave.
     * @exports IPresenceInfoSave
     * @interface IPresenceInfoSave
     * @property {Uint8Array} value PresenceInfoSave value
     * @property {number|Long} time PresenceInfoSave time
     */

    /**
     * Constructs a new PresenceInfoSave.
     * @exports PresenceInfoSave
     * @classdesc Represents a PresenceInfoSave.
     * @implements IPresenceInfoSave
     * @constructor
     * @param {IPresenceInfoSave=} [properties] Properties to set
     */
    function PresenceInfoSave(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PresenceInfoSave value.
     * @member {Uint8Array} value
     * @memberof PresenceInfoSave
     * @instance
     */
    PresenceInfoSave.prototype.value = $util.newBuffer([]);

    /**
     * PresenceInfoSave time.
     * @member {number|Long} time
     * @memberof PresenceInfoSave
     * @instance
     */
    PresenceInfoSave.prototype.time = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new PresenceInfoSave instance using the specified properties.
     * @function create
     * @memberof PresenceInfoSave
     * @static
     * @param {IPresenceInfoSave=} [properties] Properties to set
     * @returns {PresenceInfoSave} PresenceInfoSave instance
     */
    PresenceInfoSave.create = function create(properties) {
        return new PresenceInfoSave(properties);
    };

    /**
     * Encodes the specified PresenceInfoSave message. Does not implicitly {@link PresenceInfoSave.verify|verify} messages.
     * @function encode
     * @memberof PresenceInfoSave
     * @static
     * @param {IPresenceInfoSave} message PresenceInfoSave message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PresenceInfoSave.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.value);
        writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.time);
        return writer;
    };

    /**
     * Encodes the specified PresenceInfoSave message, length delimited. Does not implicitly {@link PresenceInfoSave.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PresenceInfoSave
     * @static
     * @param {IPresenceInfoSave} message PresenceInfoSave message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PresenceInfoSave.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PresenceInfoSave message from the specified reader or buffer.
     * @function decode
     * @memberof PresenceInfoSave
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PresenceInfoSave} PresenceInfoSave
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PresenceInfoSave.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new PresenceInfoSave();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.value = reader.bytes();
                break;
            case 2:
                message.time = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        if (!message.hasOwnProperty("time"))
            throw $util.ProtocolError("missing required 'time'", { instance: message });
        return message;
    };

    /**
     * Decodes a PresenceInfoSave message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PresenceInfoSave
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PresenceInfoSave} PresenceInfoSave
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PresenceInfoSave.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PresenceInfoSave message.
     * @function verify
     * @memberof PresenceInfoSave
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PresenceInfoSave.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
            return "value: buffer expected";
        if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
            return "time: integer|Long expected";
        return null;
    };

    /**
     * Creates a PresenceInfoSave message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PresenceInfoSave
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PresenceInfoSave} PresenceInfoSave
     */
    PresenceInfoSave.fromObject = function fromObject(object) {
        if (object instanceof PresenceInfoSave)
            return object;
        let message = new PresenceInfoSave();
        if (object.value != null)
            if (typeof object.value === "string")
                $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
            else if (object.value.length)
                message.value = object.value;
        if (object.time != null)
            if ($util.Long)
                (message.time = $util.Long.fromValue(object.time)).unsigned = true;
            else if (typeof object.time === "string")
                message.time = parseInt(object.time, 10);
            else if (typeof object.time === "number")
                message.time = object.time;
            else if (typeof object.time === "object")
                message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a PresenceInfoSave message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PresenceInfoSave
     * @static
     * @param {PresenceInfoSave} message PresenceInfoSave
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PresenceInfoSave.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.value = "";
            else {
                object.value = [];
                if (options.bytes !== Array)
                    object.value = $util.newBuffer(object.value);
            }
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.time = options.longs === String ? "0" : 0;
        }
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
        if (message.time != null && message.hasOwnProperty("time"))
            if (typeof message.time === "number")
                object.time = options.longs === String ? String(message.time) : message.time;
            else
                object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber(true) : message.time;
        return object;
    };

    /**
     * Converts this PresenceInfoSave to JSON.
     * @function toJSON
     * @memberof PresenceInfoSave
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PresenceInfoSave.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PresenceInfoSave;
})();

export const PresenceSave = /*@__PURE__*/ (() => {

    /**
     * Properties of a PresenceSave.
     * @exports IPresenceSave
     * @interface IPresenceSave
     * @property {Object.<string,IPresenceInfoSave>|null} [state] PresenceSave state
     * @property {string} saverID PresenceSave saverID
     */

    /**
     * Constructs a new PresenceSave.
     * @exports PresenceSave
     * @classdesc Represents a PresenceSave.
     * @implements IPresenceSave
     * @constructor
     * @param {IPresenceSave=} [properties] Properties to set
     */
    function PresenceSave(properties) {
        this.state = {};
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PresenceSave state.
     * @member {Object.<string,IPresenceInfoSave>} state
     * @memberof PresenceSave
     * @instance
     */
    PresenceSave.prototype.state = $util.emptyObject;

    /**
     * PresenceSave saverID.
     * @member {string} saverID
     * @memberof PresenceSave
     * @instance
     */
    PresenceSave.prototype.saverID = "";

    /**
     * Creates a new PresenceSave instance using the specified properties.
     * @function create
     * @memberof PresenceSave
     * @static
     * @param {IPresenceSave=} [properties] Properties to set
     * @returns {PresenceSave} PresenceSave instance
     */
    PresenceSave.create = function create(properties) {
        return new PresenceSave(properties);
    };

    /**
     * Encodes the specified PresenceSave message. Does not implicitly {@link PresenceSave.verify|verify} messages.
     * @function encode
     * @memberof PresenceSave
     * @static
     * @param {IPresenceSave} message PresenceSave message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PresenceSave.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
            for (let keys = Object.keys(message.state), i = 0; i < keys.length; ++i) {
                writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                PresenceInfoSave.encode(message.state[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
            }
        writer.uint32(/* id 2, wireType 2 =*/18).string(message.saverID);
        return writer;
    };

    /**
     * Encodes the specified PresenceSave message, length delimited. Does not implicitly {@link PresenceSave.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PresenceSave
     * @static
     * @param {IPresenceSave} message PresenceSave message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PresenceSave.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PresenceSave message from the specified reader or buffer.
     * @function decode
     * @memberof PresenceSave
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PresenceSave} PresenceSave
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PresenceSave.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new PresenceSave(), key;
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                reader.skip().pos++;
                if (message.state === $util.emptyObject)
                    message.state = {};
                key = reader.string();
                reader.pos++;
                message.state[key] = PresenceInfoSave.decode(reader, reader.uint32());
                break;
            case 2:
                message.saverID = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("saverID"))
            throw $util.ProtocolError("missing required 'saverID'", { instance: message });
        return message;
    };

    /**
     * Decodes a PresenceSave message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PresenceSave
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PresenceSave} PresenceSave
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PresenceSave.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PresenceSave message.
     * @function verify
     * @memberof PresenceSave
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PresenceSave.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.state != null && message.hasOwnProperty("state")) {
            if (!$util.isObject(message.state))
                return "state: object expected";
            let key = Object.keys(message.state);
            for (let i = 0; i < key.length; ++i) {
                let error = PresenceInfoSave.verify(message.state[key[i]]);
                if (error)
                    return "state." + error;
            }
        }
        if (!$util.isString(message.saverID))
            return "saverID: string expected";
        return null;
    };

    /**
     * Creates a PresenceSave message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PresenceSave
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PresenceSave} PresenceSave
     */
    PresenceSave.fromObject = function fromObject(object) {
        if (object instanceof PresenceSave)
            return object;
        let message = new PresenceSave();
        if (object.state) {
            if (typeof object.state !== "object")
                throw TypeError(".PresenceSave.state: object expected");
            message.state = {};
            for (let keys = Object.keys(object.state), i = 0; i < keys.length; ++i) {
                if (typeof object.state[keys[i]] !== "object")
                    throw TypeError(".PresenceSave.state: object expected");
                message.state[keys[i]] = PresenceInfoSave.fromObject(object.state[keys[i]]);
            }
        }
        if (object.saverID != null)
            message.saverID = String(object.saverID);
        return message;
    };

    /**
     * Creates a plain object from a PresenceSave message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PresenceSave
     * @static
     * @param {PresenceSave} message PresenceSave
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PresenceSave.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.objects || options.defaults)
            object.state = {};
        if (options.defaults)
            object.saverID = "";
        let keys2;
        if (message.state && (keys2 = Object.keys(message.state)).length) {
            object.state = {};
            for (let j = 0; j < keys2.length; ++j)
                object.state[keys2[j]] = PresenceInfoSave.toObject(message.state[keys2[j]], options);
        }
        if (message.saverID != null && message.hasOwnProperty("saverID"))
            object.saverID = message.saverID;
        return object;
    };

    /**
     * Converts this PresenceSave to JSON.
     * @function toJSON
     * @memberof PresenceSave
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PresenceSave.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PresenceSave;
})();

export const CounterMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of a CounterMessage.
     * @exports ICounterMessage
     * @interface ICounterMessage
     * @property {number|Long|null} [arg] CounterMessage arg
     */

    /**
     * Constructs a new CounterMessage.
     * @exports CounterMessage
     * @classdesc Represents a CounterMessage.
     * @implements ICounterMessage
     * @constructor
     * @param {ICounterMessage=} [properties] Properties to set
     */
    function CounterMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CounterMessage arg.
     * @member {number|Long} arg
     * @memberof CounterMessage
     * @instance
     */
    CounterMessage.prototype.arg = $util.Long ? $util.Long.fromBits(1,0,false) : 1;

    /**
     * Creates a new CounterMessage instance using the specified properties.
     * @function create
     * @memberof CounterMessage
     * @static
     * @param {ICounterMessage=} [properties] Properties to set
     * @returns {CounterMessage} CounterMessage instance
     */
    CounterMessage.create = function create(properties) {
        return new CounterMessage(properties);
    };

    /**
     * Encodes the specified CounterMessage message. Does not implicitly {@link CounterMessage.verify|verify} messages.
     * @function encode
     * @memberof CounterMessage
     * @static
     * @param {ICounterMessage} message CounterMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CounterMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.arg != null && Object.hasOwnProperty.call(message, "arg"))
            writer.uint32(/* id 1, wireType 0 =*/8).sint64(message.arg);
        return writer;
    };

    /**
     * Encodes the specified CounterMessage message, length delimited. Does not implicitly {@link CounterMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CounterMessage
     * @static
     * @param {ICounterMessage} message CounterMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CounterMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CounterMessage message from the specified reader or buffer.
     * @function decode
     * @memberof CounterMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CounterMessage} CounterMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CounterMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new CounterMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.arg = reader.sint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CounterMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CounterMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CounterMessage} CounterMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CounterMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CounterMessage message.
     * @function verify
     * @memberof CounterMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CounterMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.arg != null && message.hasOwnProperty("arg"))
            if (!$util.isInteger(message.arg) && !(message.arg && $util.isInteger(message.arg.low) && $util.isInteger(message.arg.high)))
                return "arg: integer|Long expected";
        return null;
    };

    /**
     * Creates a CounterMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CounterMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CounterMessage} CounterMessage
     */
    CounterMessage.fromObject = function fromObject(object) {
        if (object instanceof CounterMessage)
            return object;
        let message = new CounterMessage();
        if (object.arg != null)
            if ($util.Long)
                (message.arg = $util.Long.fromValue(object.arg)).unsigned = false;
            else if (typeof object.arg === "string")
                message.arg = parseInt(object.arg, 10);
            else if (typeof object.arg === "number")
                message.arg = object.arg;
            else if (typeof object.arg === "object")
                message.arg = new $util.LongBits(object.arg.low >>> 0, object.arg.high >>> 0).toNumber();
        return message;
    };

    /**
     * Creates a plain object from a CounterMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CounterMessage
     * @static
     * @param {CounterMessage} message CounterMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CounterMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            if ($util.Long) {
                let long = new $util.Long(1, 0, false);
                object.arg = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.arg = options.longs === String ? "1" : 1;
        if (message.arg != null && message.hasOwnProperty("arg"))
            if (typeof message.arg === "number")
                object.arg = options.longs === String ? String(message.arg) : message.arg;
            else
                object.arg = options.longs === String ? $util.Long.prototype.toString.call(message.arg) : options.longs === Number ? new $util.LongBits(message.arg.low >>> 0, message.arg.high >>> 0).toNumber() : message.arg;
        return object;
    };

    /**
     * Converts this CounterMessage to JSON.
     * @function toJSON
     * @memberof CounterMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CounterMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CounterMessage;
})();

export const CounterSave = /*@__PURE__*/ (() => {

    /**
     * Properties of a CounterSave.
     * @exports ICounterSave
     * @interface ICounterSave
     * @property {Object.<string,number|Long>|null} [p] CounterSave p
     * @property {Object.<string,number|Long>|null} [n] CounterSave n
     */

    /**
     * Constructs a new CounterSave.
     * @exports CounterSave
     * @classdesc Represents a CounterSave.
     * @implements ICounterSave
     * @constructor
     * @param {ICounterSave=} [properties] Properties to set
     */
    function CounterSave(properties) {
        this.p = {};
        this.n = {};
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CounterSave p.
     * @member {Object.<string,number|Long>} p
     * @memberof CounterSave
     * @instance
     */
    CounterSave.prototype.p = $util.emptyObject;

    /**
     * CounterSave n.
     * @member {Object.<string,number|Long>} n
     * @memberof CounterSave
     * @instance
     */
    CounterSave.prototype.n = $util.emptyObject;

    /**
     * Creates a new CounterSave instance using the specified properties.
     * @function create
     * @memberof CounterSave
     * @static
     * @param {ICounterSave=} [properties] Properties to set
     * @returns {CounterSave} CounterSave instance
     */
    CounterSave.create = function create(properties) {
        return new CounterSave(properties);
    };

    /**
     * Encodes the specified CounterSave message. Does not implicitly {@link CounterSave.verify|verify} messages.
     * @function encode
     * @memberof CounterSave
     * @static
     * @param {ICounterSave} message CounterSave message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CounterSave.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.p != null && Object.hasOwnProperty.call(message, "p"))
            for (let keys = Object.keys(message.p), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 0 =*/16).uint64(message.p[keys[i]]).ldelim();
        if (message.n != null && Object.hasOwnProperty.call(message, "n"))
            for (let keys = Object.keys(message.n), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 2, wireType 2 =*/18).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 0 =*/16).uint64(message.n[keys[i]]).ldelim();
        return writer;
    };

    /**
     * Encodes the specified CounterSave message, length delimited. Does not implicitly {@link CounterSave.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CounterSave
     * @static
     * @param {ICounterSave} message CounterSave message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CounterSave.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CounterSave message from the specified reader or buffer.
     * @function decode
     * @memberof CounterSave
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CounterSave} CounterSave
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CounterSave.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new CounterSave(), key;
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                reader.skip().pos++;
                if (message.p === $util.emptyObject)
                    message.p = {};
                key = reader.string();
                reader.pos++;
                message.p[key] = reader.uint64();
                break;
            case 2:
                reader.skip().pos++;
                if (message.n === $util.emptyObject)
                    message.n = {};
                key = reader.string();
                reader.pos++;
                message.n[key] = reader.uint64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CounterSave message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CounterSave
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CounterSave} CounterSave
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CounterSave.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CounterSave message.
     * @function verify
     * @memberof CounterSave
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CounterSave.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.p != null && message.hasOwnProperty("p")) {
            if (!$util.isObject(message.p))
                return "p: object expected";
            let key = Object.keys(message.p);
            for (let i = 0; i < key.length; ++i)
                if (!$util.isInteger(message.p[key[i]]) && !(message.p[key[i]] && $util.isInteger(message.p[key[i]].low) && $util.isInteger(message.p[key[i]].high)))
                    return "p: integer|Long{k:string} expected";
        }
        if (message.n != null && message.hasOwnProperty("n")) {
            if (!$util.isObject(message.n))
                return "n: object expected";
            let key = Object.keys(message.n);
            for (let i = 0; i < key.length; ++i)
                if (!$util.isInteger(message.n[key[i]]) && !(message.n[key[i]] && $util.isInteger(message.n[key[i]].low) && $util.isInteger(message.n[key[i]].high)))
                    return "n: integer|Long{k:string} expected";
        }
        return null;
    };

    /**
     * Creates a CounterSave message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CounterSave
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CounterSave} CounterSave
     */
    CounterSave.fromObject = function fromObject(object) {
        if (object instanceof CounterSave)
            return object;
        let message = new CounterSave();
        if (object.p) {
            if (typeof object.p !== "object")
                throw TypeError(".CounterSave.p: object expected");
            message.p = {};
            for (let keys = Object.keys(object.p), i = 0; i < keys.length; ++i)
                if ($util.Long)
                    (message.p[keys[i]] = $util.Long.fromValue(object.p[keys[i]])).unsigned = true;
                else if (typeof object.p[keys[i]] === "string")
                    message.p[keys[i]] = parseInt(object.p[keys[i]], 10);
                else if (typeof object.p[keys[i]] === "number")
                    message.p[keys[i]] = object.p[keys[i]];
                else if (typeof object.p[keys[i]] === "object")
                    message.p[keys[i]] = new $util.LongBits(object.p[keys[i]].low >>> 0, object.p[keys[i]].high >>> 0).toNumber(true);
        }
        if (object.n) {
            if (typeof object.n !== "object")
                throw TypeError(".CounterSave.n: object expected");
            message.n = {};
            for (let keys = Object.keys(object.n), i = 0; i < keys.length; ++i)
                if ($util.Long)
                    (message.n[keys[i]] = $util.Long.fromValue(object.n[keys[i]])).unsigned = true;
                else if (typeof object.n[keys[i]] === "string")
                    message.n[keys[i]] = parseInt(object.n[keys[i]], 10);
                else if (typeof object.n[keys[i]] === "number")
                    message.n[keys[i]] = object.n[keys[i]];
                else if (typeof object.n[keys[i]] === "object")
                    message.n[keys[i]] = new $util.LongBits(object.n[keys[i]].low >>> 0, object.n[keys[i]].high >>> 0).toNumber(true);
        }
        return message;
    };

    /**
     * Creates a plain object from a CounterSave message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CounterSave
     * @static
     * @param {CounterSave} message CounterSave
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CounterSave.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.objects || options.defaults) {
            object.p = {};
            object.n = {};
        }
        let keys2;
        if (message.p && (keys2 = Object.keys(message.p)).length) {
            object.p = {};
            for (let j = 0; j < keys2.length; ++j)
                if (typeof message.p[keys2[j]] === "number")
                    object.p[keys2[j]] = options.longs === String ? String(message.p[keys2[j]]) : message.p[keys2[j]];
                else
                    object.p[keys2[j]] = options.longs === String ? $util.Long.prototype.toString.call(message.p[keys2[j]]) : options.longs === Number ? new $util.LongBits(message.p[keys2[j]].low >>> 0, message.p[keys2[j]].high >>> 0).toNumber(true) : message.p[keys2[j]];
        }
        if (message.n && (keys2 = Object.keys(message.n)).length) {
            object.n = {};
            for (let j = 0; j < keys2.length; ++j)
                if (typeof message.n[keys2[j]] === "number")
                    object.n[keys2[j]] = options.longs === String ? String(message.n[keys2[j]]) : message.n[keys2[j]];
                else
                    object.n[keys2[j]] = options.longs === String ? $util.Long.prototype.toString.call(message.n[keys2[j]]) : options.longs === Number ? new $util.LongBits(message.n[keys2[j]].low >>> 0, message.n[keys2[j]].high >>> 0).toNumber(true) : message.n[keys2[j]];
        }
        return object;
    };

    /**
     * Converts this CounterSave to JSON.
     * @function toJSON
     * @memberof CounterSave
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CounterSave.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CounterSave;
})();

export const CausalMessageBufferSave = /*@__PURE__*/ (() => {

    /**
     * Properties of a CausalMessageBufferSave.
     * @exports ICausalMessageBufferSave
     * @interface ICausalMessageBufferSave
     * @property {Array.<string>|null} [vcKeys] CausalMessageBufferSave vcKeys
     * @property {Array.<number|Long>|null} [vcValues] CausalMessageBufferSave vcValues
     * @property {Array.<string>|null} [maximalVcKeys] CausalMessageBufferSave maximalVcKeys
     * @property {number|Long} lamportTimestamp CausalMessageBufferSave lamportTimestamp
     * @property {Array.<Uint8Array>|null} [bufferMessages] CausalMessageBufferSave bufferMessages
     */

    /**
     * Constructs a new CausalMessageBufferSave.
     * @exports CausalMessageBufferSave
     * @classdesc Represents a CausalMessageBufferSave.
     * @implements ICausalMessageBufferSave
     * @constructor
     * @param {ICausalMessageBufferSave=} [properties] Properties to set
     */
    function CausalMessageBufferSave(properties) {
        this.vcKeys = [];
        this.vcValues = [];
        this.maximalVcKeys = [];
        this.bufferMessages = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CausalMessageBufferSave vcKeys.
     * @member {Array.<string>} vcKeys
     * @memberof CausalMessageBufferSave
     * @instance
     */
    CausalMessageBufferSave.prototype.vcKeys = $util.emptyArray;

    /**
     * CausalMessageBufferSave vcValues.
     * @member {Array.<number|Long>} vcValues
     * @memberof CausalMessageBufferSave
     * @instance
     */
    CausalMessageBufferSave.prototype.vcValues = $util.emptyArray;

    /**
     * CausalMessageBufferSave maximalVcKeys.
     * @member {Array.<string>} maximalVcKeys
     * @memberof CausalMessageBufferSave
     * @instance
     */
    CausalMessageBufferSave.prototype.maximalVcKeys = $util.emptyArray;

    /**
     * CausalMessageBufferSave lamportTimestamp.
     * @member {number|Long} lamportTimestamp
     * @memberof CausalMessageBufferSave
     * @instance
     */
    CausalMessageBufferSave.prototype.lamportTimestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * CausalMessageBufferSave bufferMessages.
     * @member {Array.<Uint8Array>} bufferMessages
     * @memberof CausalMessageBufferSave
     * @instance
     */
    CausalMessageBufferSave.prototype.bufferMessages = $util.emptyArray;

    /**
     * Creates a new CausalMessageBufferSave instance using the specified properties.
     * @function create
     * @memberof CausalMessageBufferSave
     * @static
     * @param {ICausalMessageBufferSave=} [properties] Properties to set
     * @returns {CausalMessageBufferSave} CausalMessageBufferSave instance
     */
    CausalMessageBufferSave.create = function create(properties) {
        return new CausalMessageBufferSave(properties);
    };

    /**
     * Encodes the specified CausalMessageBufferSave message. Does not implicitly {@link CausalMessageBufferSave.verify|verify} messages.
     * @function encode
     * @memberof CausalMessageBufferSave
     * @static
     * @param {ICausalMessageBufferSave} message CausalMessageBufferSave message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CausalMessageBufferSave.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.vcKeys != null && message.vcKeys.length)
            for (let i = 0; i < message.vcKeys.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.vcKeys[i]);
        if (message.vcValues != null && message.vcValues.length) {
            writer.uint32(/* id 2, wireType 2 =*/18).fork();
            for (let i = 0; i < message.vcValues.length; ++i)
                writer.uint64(message.vcValues[i]);
            writer.ldelim();
        }
        if (message.maximalVcKeys != null && message.maximalVcKeys.length)
            for (let i = 0; i < message.maximalVcKeys.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.maximalVcKeys[i]);
        writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.lamportTimestamp);
        if (message.bufferMessages != null && message.bufferMessages.length)
            for (let i = 0; i < message.bufferMessages.length; ++i)
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.bufferMessages[i]);
        return writer;
    };

    /**
     * Encodes the specified CausalMessageBufferSave message, length delimited. Does not implicitly {@link CausalMessageBufferSave.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CausalMessageBufferSave
     * @static
     * @param {ICausalMessageBufferSave} message CausalMessageBufferSave message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CausalMessageBufferSave.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CausalMessageBufferSave message from the specified reader or buffer.
     * @function decode
     * @memberof CausalMessageBufferSave
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CausalMessageBufferSave} CausalMessageBufferSave
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CausalMessageBufferSave.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new CausalMessageBufferSave();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.vcKeys && message.vcKeys.length))
                    message.vcKeys = [];
                message.vcKeys.push(reader.string());
                break;
            case 2:
                if (!(message.vcValues && message.vcValues.length))
                    message.vcValues = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.vcValues.push(reader.uint64());
                } else
                    message.vcValues.push(reader.uint64());
                break;
            case 3:
                if (!(message.maximalVcKeys && message.maximalVcKeys.length))
                    message.maximalVcKeys = [];
                message.maximalVcKeys.push(reader.string());
                break;
            case 4:
                message.lamportTimestamp = reader.uint64();
                break;
            case 5:
                if (!(message.bufferMessages && message.bufferMessages.length))
                    message.bufferMessages = [];
                message.bufferMessages.push(reader.bytes());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("lamportTimestamp"))
            throw $util.ProtocolError("missing required 'lamportTimestamp'", { instance: message });
        return message;
    };

    /**
     * Decodes a CausalMessageBufferSave message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CausalMessageBufferSave
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CausalMessageBufferSave} CausalMessageBufferSave
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CausalMessageBufferSave.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CausalMessageBufferSave message.
     * @function verify
     * @memberof CausalMessageBufferSave
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CausalMessageBufferSave.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.vcKeys != null && message.hasOwnProperty("vcKeys")) {
            if (!Array.isArray(message.vcKeys))
                return "vcKeys: array expected";
            for (let i = 0; i < message.vcKeys.length; ++i)
                if (!$util.isString(message.vcKeys[i]))
                    return "vcKeys: string[] expected";
        }
        if (message.vcValues != null && message.hasOwnProperty("vcValues")) {
            if (!Array.isArray(message.vcValues))
                return "vcValues: array expected";
            for (let i = 0; i < message.vcValues.length; ++i)
                if (!$util.isInteger(message.vcValues[i]) && !(message.vcValues[i] && $util.isInteger(message.vcValues[i].low) && $util.isInteger(message.vcValues[i].high)))
                    return "vcValues: integer|Long[] expected";
        }
        if (message.maximalVcKeys != null && message.hasOwnProperty("maximalVcKeys")) {
            if (!Array.isArray(message.maximalVcKeys))
                return "maximalVcKeys: array expected";
            for (let i = 0; i < message.maximalVcKeys.length; ++i)
                if (!$util.isString(message.maximalVcKeys[i]))
                    return "maximalVcKeys: string[] expected";
        }
        if (!$util.isInteger(message.lamportTimestamp) && !(message.lamportTimestamp && $util.isInteger(message.lamportTimestamp.low) && $util.isInteger(message.lamportTimestamp.high)))
            return "lamportTimestamp: integer|Long expected";
        if (message.bufferMessages != null && message.hasOwnProperty("bufferMessages")) {
            if (!Array.isArray(message.bufferMessages))
                return "bufferMessages: array expected";
            for (let i = 0; i < message.bufferMessages.length; ++i)
                if (!(message.bufferMessages[i] && typeof message.bufferMessages[i].length === "number" || $util.isString(message.bufferMessages[i])))
                    return "bufferMessages: buffer[] expected";
        }
        return null;
    };

    /**
     * Creates a CausalMessageBufferSave message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CausalMessageBufferSave
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CausalMessageBufferSave} CausalMessageBufferSave
     */
    CausalMessageBufferSave.fromObject = function fromObject(object) {
        if (object instanceof CausalMessageBufferSave)
            return object;
        let message = new CausalMessageBufferSave();
        if (object.vcKeys) {
            if (!Array.isArray(object.vcKeys))
                throw TypeError(".CausalMessageBufferSave.vcKeys: array expected");
            message.vcKeys = [];
            for (let i = 0; i < object.vcKeys.length; ++i)
                message.vcKeys[i] = String(object.vcKeys[i]);
        }
        if (object.vcValues) {
            if (!Array.isArray(object.vcValues))
                throw TypeError(".CausalMessageBufferSave.vcValues: array expected");
            message.vcValues = [];
            for (let i = 0; i < object.vcValues.length; ++i)
                if ($util.Long)
                    (message.vcValues[i] = $util.Long.fromValue(object.vcValues[i])).unsigned = true;
                else if (typeof object.vcValues[i] === "string")
                    message.vcValues[i] = parseInt(object.vcValues[i], 10);
                else if (typeof object.vcValues[i] === "number")
                    message.vcValues[i] = object.vcValues[i];
                else if (typeof object.vcValues[i] === "object")
                    message.vcValues[i] = new $util.LongBits(object.vcValues[i].low >>> 0, object.vcValues[i].high >>> 0).toNumber(true);
        }
        if (object.maximalVcKeys) {
            if (!Array.isArray(object.maximalVcKeys))
                throw TypeError(".CausalMessageBufferSave.maximalVcKeys: array expected");
            message.maximalVcKeys = [];
            for (let i = 0; i < object.maximalVcKeys.length; ++i)
                message.maximalVcKeys[i] = String(object.maximalVcKeys[i]);
        }
        if (object.lamportTimestamp != null)
            if ($util.Long)
                (message.lamportTimestamp = $util.Long.fromValue(object.lamportTimestamp)).unsigned = true;
            else if (typeof object.lamportTimestamp === "string")
                message.lamportTimestamp = parseInt(object.lamportTimestamp, 10);
            else if (typeof object.lamportTimestamp === "number")
                message.lamportTimestamp = object.lamportTimestamp;
            else if (typeof object.lamportTimestamp === "object")
                message.lamportTimestamp = new $util.LongBits(object.lamportTimestamp.low >>> 0, object.lamportTimestamp.high >>> 0).toNumber(true);
        if (object.bufferMessages) {
            if (!Array.isArray(object.bufferMessages))
                throw TypeError(".CausalMessageBufferSave.bufferMessages: array expected");
            message.bufferMessages = [];
            for (let i = 0; i < object.bufferMessages.length; ++i)
                if (typeof object.bufferMessages[i] === "string")
                    $util.base64.decode(object.bufferMessages[i], message.bufferMessages[i] = $util.newBuffer($util.base64.length(object.bufferMessages[i])), 0);
                else if (object.bufferMessages[i].length)
                    message.bufferMessages[i] = object.bufferMessages[i];
        }
        return message;
    };

    /**
     * Creates a plain object from a CausalMessageBufferSave message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CausalMessageBufferSave
     * @static
     * @param {CausalMessageBufferSave} message CausalMessageBufferSave
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CausalMessageBufferSave.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.vcKeys = [];
            object.vcValues = [];
            object.maximalVcKeys = [];
            object.bufferMessages = [];
        }
        if (options.defaults)
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.lamportTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.lamportTimestamp = options.longs === String ? "0" : 0;
        if (message.vcKeys && message.vcKeys.length) {
            object.vcKeys = [];
            for (let j = 0; j < message.vcKeys.length; ++j)
                object.vcKeys[j] = message.vcKeys[j];
        }
        if (message.vcValues && message.vcValues.length) {
            object.vcValues = [];
            for (let j = 0; j < message.vcValues.length; ++j)
                if (typeof message.vcValues[j] === "number")
                    object.vcValues[j] = options.longs === String ? String(message.vcValues[j]) : message.vcValues[j];
                else
                    object.vcValues[j] = options.longs === String ? $util.Long.prototype.toString.call(message.vcValues[j]) : options.longs === Number ? new $util.LongBits(message.vcValues[j].low >>> 0, message.vcValues[j].high >>> 0).toNumber(true) : message.vcValues[j];
        }
        if (message.maximalVcKeys && message.maximalVcKeys.length) {
            object.maximalVcKeys = [];
            for (let j = 0; j < message.maximalVcKeys.length; ++j)
                object.maximalVcKeys[j] = message.maximalVcKeys[j];
        }
        if (message.lamportTimestamp != null && message.hasOwnProperty("lamportTimestamp"))
            if (typeof message.lamportTimestamp === "number")
                object.lamportTimestamp = options.longs === String ? String(message.lamportTimestamp) : message.lamportTimestamp;
            else
                object.lamportTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.lamportTimestamp) : options.longs === Number ? new $util.LongBits(message.lamportTimestamp.low >>> 0, message.lamportTimestamp.high >>> 0).toNumber(true) : message.lamportTimestamp;
        if (message.bufferMessages && message.bufferMessages.length) {
            object.bufferMessages = [];
            for (let j = 0; j < message.bufferMessages.length; ++j)
                object.bufferMessages[j] = options.bytes === String ? $util.base64.encode(message.bufferMessages[j], 0, message.bufferMessages[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.bufferMessages[j]) : message.bufferMessages[j];
        }
        return object;
    };

    /**
     * Converts this CausalMessageBufferSave to JSON.
     * @function toJSON
     * @memberof CausalMessageBufferSave
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CausalMessageBufferSave.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CausalMessageBufferSave;
})();

export const CRDTMessageMetaMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of a CRDTMessageMetaMessage.
     * @exports ICRDTMessageMetaMessage
     * @interface ICRDTMessageMetaMessage
     * @property {string} senderID CRDTMessageMetaMessage senderID
     * @property {number} senderCounter CRDTMessageMetaMessage senderCounter
     * @property {Array.<string>|null} [vcKeys] CRDTMessageMetaMessage vcKeys
     * @property {Array.<number>|null} [vcValues] CRDTMessageMetaMessage vcValues
     * @property {number|null} [maximalVcKeyCount] CRDTMessageMetaMessage maximalVcKeyCount
     * @property {number|Long|null} [wallClockTime] CRDTMessageMetaMessage wallClockTime
     * @property {number|Long|null} [lamportTimestamp] CRDTMessageMetaMessage lamportTimestamp
     * @property {Array.<number>|null} [encodedVcKeys] CRDTMessageMetaMessage encodedVcKeys
     */

    /**
     * Constructs a new CRDTMessageMetaMessage.
     * @exports CRDTMessageMetaMessage
     * @classdesc Represents a CRDTMessageMetaMessage.
     * @implements ICRDTMessageMetaMessage
     * @constructor
     * @param {ICRDTMessageMetaMessage=} [properties] Properties to set
     */
    function CRDTMessageMetaMessage(properties) {
        this.vcKeys = [];
        this.vcValues = [];
        this.encodedVcKeys = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CRDTMessageMetaMessage senderID.
     * @member {string} senderID
     * @memberof CRDTMessageMetaMessage
     * @instance
     */
    CRDTMessageMetaMessage.prototype.senderID = "";

    /**
     * CRDTMessageMetaMessage senderCounter.
     * @member {number} senderCounter
     * @memberof CRDTMessageMetaMessage
     * @instance
     */
    CRDTMessageMetaMessage.prototype.senderCounter = 0;

    /**
     * CRDTMessageMetaMessage vcKeys.
     * @member {Array.<string>} vcKeys
     * @memberof CRDTMessageMetaMessage
     * @instance
     */
    CRDTMessageMetaMessage.prototype.vcKeys = $util.emptyArray;

    /**
     * CRDTMessageMetaMessage vcValues.
     * @member {Array.<number>} vcValues
     * @memberof CRDTMessageMetaMessage
     * @instance
     */
    CRDTMessageMetaMessage.prototype.vcValues = $util.emptyArray;

    /**
     * CRDTMessageMetaMessage maximalVcKeyCount.
     * @member {number} maximalVcKeyCount
     * @memberof CRDTMessageMetaMessage
     * @instance
     */
    CRDTMessageMetaMessage.prototype.maximalVcKeyCount = 0;

    /**
     * CRDTMessageMetaMessage wallClockTime.
     * @member {number|Long} wallClockTime
     * @memberof CRDTMessageMetaMessage
     * @instance
     */
    CRDTMessageMetaMessage.prototype.wallClockTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * CRDTMessageMetaMessage lamportTimestamp.
     * @member {number|Long} lamportTimestamp
     * @memberof CRDTMessageMetaMessage
     * @instance
     */
    CRDTMessageMetaMessage.prototype.lamportTimestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * CRDTMessageMetaMessage encodedVcKeys.
     * @member {Array.<number>} encodedVcKeys
     * @memberof CRDTMessageMetaMessage
     * @instance
     */
    CRDTMessageMetaMessage.prototype.encodedVcKeys = $util.emptyArray;

    /**
     * Creates a new CRDTMessageMetaMessage instance using the specified properties.
     * @function create
     * @memberof CRDTMessageMetaMessage
     * @static
     * @param {ICRDTMessageMetaMessage=} [properties] Properties to set
     * @returns {CRDTMessageMetaMessage} CRDTMessageMetaMessage instance
     */
    CRDTMessageMetaMessage.create = function create(properties) {
        return new CRDTMessageMetaMessage(properties);
    };

    /**
     * Encodes the specified CRDTMessageMetaMessage message. Does not implicitly {@link CRDTMessageMetaMessage.verify|verify} messages.
     * @function encode
     * @memberof CRDTMessageMetaMessage
     * @static
     * @param {ICRDTMessageMetaMessage} message CRDTMessageMetaMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CRDTMessageMetaMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.senderID);
        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.senderCounter);
        if (message.vcKeys != null && message.vcKeys.length)
            for (let i = 0; i < message.vcKeys.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.vcKeys[i]);
        if (message.vcValues != null && message.vcValues.length) {
            writer.uint32(/* id 4, wireType 2 =*/34).fork();
            for (let i = 0; i < message.vcValues.length; ++i)
                writer.uint32(message.vcValues[i]);
            writer.ldelim();
        }
        if (message.maximalVcKeyCount != null && Object.hasOwnProperty.call(message, "maximalVcKeyCount"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.maximalVcKeyCount);
        if (message.wallClockTime != null && Object.hasOwnProperty.call(message, "wallClockTime"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.wallClockTime);
        if (message.lamportTimestamp != null && Object.hasOwnProperty.call(message, "lamportTimestamp"))
            writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.lamportTimestamp);
        if (message.encodedVcKeys != null && message.encodedVcKeys.length) {
            writer.uint32(/* id 8, wireType 2 =*/66).fork();
            for (let i = 0; i < message.encodedVcKeys.length; ++i)
                writer.uint32(message.encodedVcKeys[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified CRDTMessageMetaMessage message, length delimited. Does not implicitly {@link CRDTMessageMetaMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CRDTMessageMetaMessage
     * @static
     * @param {ICRDTMessageMetaMessage} message CRDTMessageMetaMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CRDTMessageMetaMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CRDTMessageMetaMessage message from the specified reader or buffer.
     * @function decode
     * @memberof CRDTMessageMetaMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CRDTMessageMetaMessage} CRDTMessageMetaMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CRDTMessageMetaMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new CRDTMessageMetaMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.senderID = reader.string();
                break;
            case 2:
                message.senderCounter = reader.uint32();
                break;
            case 3:
                if (!(message.vcKeys && message.vcKeys.length))
                    message.vcKeys = [];
                message.vcKeys.push(reader.string());
                break;
            case 4:
                if (!(message.vcValues && message.vcValues.length))
                    message.vcValues = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.vcValues.push(reader.uint32());
                } else
                    message.vcValues.push(reader.uint32());
                break;
            case 5:
                message.maximalVcKeyCount = reader.uint32();
                break;
            case 6:
                message.wallClockTime = reader.uint64();
                break;
            case 7:
                message.lamportTimestamp = reader.uint64();
                break;
            case 8:
                if (!(message.encodedVcKeys && message.encodedVcKeys.length))
                    message.encodedVcKeys = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.encodedVcKeys.push(reader.uint32());
                } else
                    message.encodedVcKeys.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("senderID"))
            throw $util.ProtocolError("missing required 'senderID'", { instance: message });
        if (!message.hasOwnProperty("senderCounter"))
            throw $util.ProtocolError("missing required 'senderCounter'", { instance: message });
        return message;
    };

    /**
     * Decodes a CRDTMessageMetaMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CRDTMessageMetaMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CRDTMessageMetaMessage} CRDTMessageMetaMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CRDTMessageMetaMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CRDTMessageMetaMessage message.
     * @function verify
     * @memberof CRDTMessageMetaMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CRDTMessageMetaMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.senderID))
            return "senderID: string expected";
        if (!$util.isInteger(message.senderCounter))
            return "senderCounter: integer expected";
        if (message.vcKeys != null && message.hasOwnProperty("vcKeys")) {
            if (!Array.isArray(message.vcKeys))
                return "vcKeys: array expected";
            for (let i = 0; i < message.vcKeys.length; ++i)
                if (!$util.isString(message.vcKeys[i]))
                    return "vcKeys: string[] expected";
        }
        if (message.vcValues != null && message.hasOwnProperty("vcValues")) {
            if (!Array.isArray(message.vcValues))
                return "vcValues: array expected";
            for (let i = 0; i < message.vcValues.length; ++i)
                if (!$util.isInteger(message.vcValues[i]))
                    return "vcValues: integer[] expected";
        }
        if (message.maximalVcKeyCount != null && message.hasOwnProperty("maximalVcKeyCount"))
            if (!$util.isInteger(message.maximalVcKeyCount))
                return "maximalVcKeyCount: integer expected";
        if (message.wallClockTime != null && message.hasOwnProperty("wallClockTime"))
            if (!$util.isInteger(message.wallClockTime) && !(message.wallClockTime && $util.isInteger(message.wallClockTime.low) && $util.isInteger(message.wallClockTime.high)))
                return "wallClockTime: integer|Long expected";
        if (message.lamportTimestamp != null && message.hasOwnProperty("lamportTimestamp"))
            if (!$util.isInteger(message.lamportTimestamp) && !(message.lamportTimestamp && $util.isInteger(message.lamportTimestamp.low) && $util.isInteger(message.lamportTimestamp.high)))
                return "lamportTimestamp: integer|Long expected";
        if (message.encodedVcKeys != null && message.hasOwnProperty("encodedVcKeys")) {
            if (!Array.isArray(message.encodedVcKeys))
                return "encodedVcKeys: array expected";
            for (let i = 0; i < message.encodedVcKeys.length; ++i)
                if (!$util.isInteger(message.encodedVcKeys[i]))
                    return "encodedVcKeys: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a CRDTMessageMetaMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CRDTMessageMetaMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CRDTMessageMetaMessage} CRDTMessageMetaMessage
     */
    CRDTMessageMetaMessage.fromObject = function fromObject(object) {
        if (object instanceof CRDTMessageMetaMessage)
            return object;
        let message = new CRDTMessageMetaMessage();
        if (object.senderID != null)
            message.senderID = String(object.senderID);
        if (object.senderCounter != null)
            message.senderCounter = object.senderCounter >>> 0;
        if (object.vcKeys) {
            if (!Array.isArray(object.vcKeys))
                throw TypeError(".CRDTMessageMetaMessage.vcKeys: array expected");
            message.vcKeys = [];
            for (let i = 0; i < object.vcKeys.length; ++i)
                message.vcKeys[i] = String(object.vcKeys[i]);
        }
        if (object.vcValues) {
            if (!Array.isArray(object.vcValues))
                throw TypeError(".CRDTMessageMetaMessage.vcValues: array expected");
            message.vcValues = [];
            for (let i = 0; i < object.vcValues.length; ++i)
                message.vcValues[i] = object.vcValues[i] >>> 0;
        }
        if (object.maximalVcKeyCount != null)
            message.maximalVcKeyCount = object.maximalVcKeyCount >>> 0;
        if (object.wallClockTime != null)
            if ($util.Long)
                (message.wallClockTime = $util.Long.fromValue(object.wallClockTime)).unsigned = true;
            else if (typeof object.wallClockTime === "string")
                message.wallClockTime = parseInt(object.wallClockTime, 10);
            else if (typeof object.wallClockTime === "number")
                message.wallClockTime = object.wallClockTime;
            else if (typeof object.wallClockTime === "object")
                message.wallClockTime = new $util.LongBits(object.wallClockTime.low >>> 0, object.wallClockTime.high >>> 0).toNumber(true);
        if (object.lamportTimestamp != null)
            if ($util.Long)
                (message.lamportTimestamp = $util.Long.fromValue(object.lamportTimestamp)).unsigned = true;
            else if (typeof object.lamportTimestamp === "string")
                message.lamportTimestamp = parseInt(object.lamportTimestamp, 10);
            else if (typeof object.lamportTimestamp === "number")
                message.lamportTimestamp = object.lamportTimestamp;
            else if (typeof object.lamportTimestamp === "object")
                message.lamportTimestamp = new $util.LongBits(object.lamportTimestamp.low >>> 0, object.lamportTimestamp.high >>> 0).toNumber(true);
        if (object.encodedVcKeys) {
            if (!Array.isArray(object.encodedVcKeys))
                throw TypeError(".CRDTMessageMetaMessage.encodedVcKeys: array expected");
            message.encodedVcKeys = [];
            for (let i = 0; i < object.encodedVcKeys.length; ++i)
                message.encodedVcKeys[i] = object.encodedVcKeys[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a CRDTMessageMetaMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CRDTMessageMetaMessage
     * @static
     * @param {CRDTMessageMetaMessage} message CRDTMessageMetaMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CRDTMessageMetaMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.vcKeys = [];
            object.vcValues = [];
            object.encodedVcKeys = [];
        }
        if (options.defaults) {
            object.senderID = "";
            object.senderCounter = 0;
            object.maximalVcKeyCount = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.wallClockTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.wallClockTime = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.lamportTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.lamportTimestamp = options.longs === String ? "0" : 0;
        }
        if (message.senderID != null && message.hasOwnProperty("senderID"))
            object.senderID = message.senderID;
        if (message.senderCounter != null && message.hasOwnProperty("senderCounter"))
            object.senderCounter = message.senderCounter;
        if (message.vcKeys && message.vcKeys.length) {
            object.vcKeys = [];
            for (let j = 0; j < message.vcKeys.length; ++j)
                object.vcKeys[j] = message.vcKeys[j];
        }
        if (message.vcValues && message.vcValues.length) {
            object.vcValues = [];
            for (let j = 0; j < message.vcValues.length; ++j)
                object.vcValues[j] = message.vcValues[j];
        }
        if (message.maximalVcKeyCount != null && message.hasOwnProperty("maximalVcKeyCount"))
            object.maximalVcKeyCount = message.maximalVcKeyCount;
        if (message.wallClockTime != null && message.hasOwnProperty("wallClockTime"))
            if (typeof message.wallClockTime === "number")
                object.wallClockTime = options.longs === String ? String(message.wallClockTime) : message.wallClockTime;
            else
                object.wallClockTime = options.longs === String ? $util.Long.prototype.toString.call(message.wallClockTime) : options.longs === Number ? new $util.LongBits(message.wallClockTime.low >>> 0, message.wallClockTime.high >>> 0).toNumber(true) : message.wallClockTime;
        if (message.lamportTimestamp != null && message.hasOwnProperty("lamportTimestamp"))
            if (typeof message.lamportTimestamp === "number")
                object.lamportTimestamp = options.longs === String ? String(message.lamportTimestamp) : message.lamportTimestamp;
            else
                object.lamportTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.lamportTimestamp) : options.longs === Number ? new $util.LongBits(message.lamportTimestamp.low >>> 0, message.lamportTimestamp.high >>> 0).toNumber(true) : message.lamportTimestamp;
        if (message.encodedVcKeys && message.encodedVcKeys.length) {
            object.encodedVcKeys = [];
            for (let j = 0; j < message.encodedVcKeys.length; ++j)
                object.encodedVcKeys[j] = message.encodedVcKeys[j];
        }
        return object;
    };

    /**
     * Converts this CRDTMessageMetaMessage to JSON.
     * @function toJSON
     * @memberof CRDTMessageMetaMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CRDTMessageMetaMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CRDTMessageMetaMessage;
})();

export const MessageSerializerMergeInfo = /*@__PURE__*/ (() => {

    /**
     * Properties of a MessageSerializerMergeInfo.
     * @exports IMessageSerializerMergeInfo
     * @interface IMessageSerializerMergeInfo
     * @property {Array.<string>|null} [replicaIDs] MessageSerializerMergeInfo replicaIDs
     * @property {Array.<number>|null} [lengths] MessageSerializerMergeInfo lengths
     */

    /**
     * Constructs a new MessageSerializerMergeInfo.
     * @exports MessageSerializerMergeInfo
     * @classdesc Represents a MessageSerializerMergeInfo.
     * @implements IMessageSerializerMergeInfo
     * @constructor
     * @param {IMessageSerializerMergeInfo=} [properties] Properties to set
     */
    function MessageSerializerMergeInfo(properties) {
        this.replicaIDs = [];
        this.lengths = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MessageSerializerMergeInfo replicaIDs.
     * @member {Array.<string>} replicaIDs
     * @memberof MessageSerializerMergeInfo
     * @instance
     */
    MessageSerializerMergeInfo.prototype.replicaIDs = $util.emptyArray;

    /**
     * MessageSerializerMergeInfo lengths.
     * @member {Array.<number>} lengths
     * @memberof MessageSerializerMergeInfo
     * @instance
     */
    MessageSerializerMergeInfo.prototype.lengths = $util.emptyArray;

    /**
     * Creates a new MessageSerializerMergeInfo instance using the specified properties.
     * @function create
     * @memberof MessageSerializerMergeInfo
     * @static
     * @param {IMessageSerializerMergeInfo=} [properties] Properties to set
     * @returns {MessageSerializerMergeInfo} MessageSerializerMergeInfo instance
     */
    MessageSerializerMergeInfo.create = function create(properties) {
        return new MessageSerializerMergeInfo(properties);
    };

    /**
     * Encodes the specified MessageSerializerMergeInfo message. Does not implicitly {@link MessageSerializerMergeInfo.verify|verify} messages.
     * @function encode
     * @memberof MessageSerializerMergeInfo
     * @static
     * @param {IMessageSerializerMergeInfo} message MessageSerializerMergeInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MessageSerializerMergeInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.replicaIDs != null && message.replicaIDs.length)
            for (let i = 0; i < message.replicaIDs.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.replicaIDs[i]);
        if (message.lengths != null && message.lengths.length) {
            writer.uint32(/* id 2, wireType 2 =*/18).fork();
            for (let i = 0; i < message.lengths.length; ++i)
                writer.uint32(message.lengths[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified MessageSerializerMergeInfo message, length delimited. Does not implicitly {@link MessageSerializerMergeInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MessageSerializerMergeInfo
     * @static
     * @param {IMessageSerializerMergeInfo} message MessageSerializerMergeInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MessageSerializerMergeInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MessageSerializerMergeInfo message from the specified reader or buffer.
     * @function decode
     * @memberof MessageSerializerMergeInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MessageSerializerMergeInfo} MessageSerializerMergeInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MessageSerializerMergeInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new MessageSerializerMergeInfo();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.replicaIDs && message.replicaIDs.length))
                    message.replicaIDs = [];
                message.replicaIDs.push(reader.string());
                break;
            case 2:
                if (!(message.lengths && message.lengths.length))
                    message.lengths = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.lengths.push(reader.uint32());
                } else
                    message.lengths.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MessageSerializerMergeInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MessageSerializerMergeInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MessageSerializerMergeInfo} MessageSerializerMergeInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MessageSerializerMergeInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MessageSerializerMergeInfo message.
     * @function verify
     * @memberof MessageSerializerMergeInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MessageSerializerMergeInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.replicaIDs != null && message.hasOwnProperty("replicaIDs")) {
            if (!Array.isArray(message.replicaIDs))
                return "replicaIDs: array expected";
            for (let i = 0; i < message.replicaIDs.length; ++i)
                if (!$util.isString(message.replicaIDs[i]))
                    return "replicaIDs: string[] expected";
        }
        if (message.lengths != null && message.hasOwnProperty("lengths")) {
            if (!Array.isArray(message.lengths))
                return "lengths: array expected";
            for (let i = 0; i < message.lengths.length; ++i)
                if (!$util.isInteger(message.lengths[i]))
                    return "lengths: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a MessageSerializerMergeInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MessageSerializerMergeInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MessageSerializerMergeInfo} MessageSerializerMergeInfo
     */
    MessageSerializerMergeInfo.fromObject = function fromObject(object) {
        if (object instanceof MessageSerializerMergeInfo)
            return object;
        let message = new MessageSerializerMergeInfo();
        if (object.replicaIDs) {
            if (!Array.isArray(object.replicaIDs))
                throw TypeError(".MessageSerializerMergeInfo.replicaIDs: array expected");
            message.replicaIDs = [];
            for (let i = 0; i < object.replicaIDs.length; ++i)
                message.replicaIDs[i] = String(object.replicaIDs[i]);
        }
        if (object.lengths) {
            if (!Array.isArray(object.lengths))
                throw TypeError(".MessageSerializerMergeInfo.lengths: array expected");
            message.lengths = [];
            for (let i = 0; i < object.lengths.length; ++i)
                message.lengths[i] = object.lengths[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a MessageSerializerMergeInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MessageSerializerMergeInfo
     * @static
     * @param {MessageSerializerMergeInfo} message MessageSerializerMergeInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MessageSerializerMergeInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.replicaIDs = [];
            object.lengths = [];
        }
        if (message.replicaIDs && message.replicaIDs.length) {
            object.replicaIDs = [];
            for (let j = 0; j < message.replicaIDs.length; ++j)
                object.replicaIDs[j] = message.replicaIDs[j];
        }
        if (message.lengths && message.lengths.length) {
            object.lengths = [];
            for (let j = 0; j < message.lengths.length; ++j)
                object.lengths[j] = message.lengths[j];
        }
        return object;
    };

    /**
     * Converts this MessageSerializerMergeInfo to JSON.
     * @function toJSON
     * @memberof MessageSerializerMergeInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MessageSerializerMergeInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MessageSerializerMergeInfo;
})();

export const CSetMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of a CSetMessage.
     * @exports ICSetMessage
     * @interface ICSetMessage
     * @property {Uint8Array|null} [add] CSetMessage add
     * @property {string|null} ["delete"] CSetMessage delete
     */

    /**
     * Constructs a new CSetMessage.
     * @exports CSetMessage
     * @classdesc Represents a CSetMessage.
     * @implements ICSetMessage
     * @constructor
     * @param {ICSetMessage=} [properties] Properties to set
     */
    function CSetMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CSetMessage add.
     * @member {Uint8Array} add
     * @memberof CSetMessage
     * @instance
     */
    CSetMessage.prototype.add = $util.newBuffer([]);

    /**
     * CSetMessage delete.
     * @member {string} delete
     * @memberof CSetMessage
     * @instance
     */
    CSetMessage.prototype["delete"] = "";

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * CSetMessage op.
     * @member {"add"|"delete"|undefined} op
     * @memberof CSetMessage
     * @instance
     */
    Object.defineProperty(CSetMessage.prototype, "op", {
        get: $util.oneOfGetter($oneOfFields = ["add", "delete"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new CSetMessage instance using the specified properties.
     * @function create
     * @memberof CSetMessage
     * @static
     * @param {ICSetMessage=} [properties] Properties to set
     * @returns {CSetMessage} CSetMessage instance
     */
    CSetMessage.create = function create(properties) {
        return new CSetMessage(properties);
    };

    /**
     * Encodes the specified CSetMessage message. Does not implicitly {@link CSetMessage.verify|verify} messages.
     * @function encode
     * @memberof CSetMessage
     * @static
     * @param {ICSetMessage} message CSetMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CSetMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.add != null && Object.hasOwnProperty.call(message, "add"))
            writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.add);
        if (message["delete"] != null && Object.hasOwnProperty.call(message, "delete"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message["delete"]);
        return writer;
    };

    /**
     * Encodes the specified CSetMessage message, length delimited. Does not implicitly {@link CSetMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CSetMessage
     * @static
     * @param {ICSetMessage} message CSetMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CSetMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CSetMessage message from the specified reader or buffer.
     * @function decode
     * @memberof CSetMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CSetMessage} CSetMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CSetMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new CSetMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.add = reader.bytes();
                break;
            case 2:
                message["delete"] = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CSetMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CSetMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CSetMessage} CSetMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CSetMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CSetMessage message.
     * @function verify
     * @memberof CSetMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CSetMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        let properties = {};
        if (message.add != null && message.hasOwnProperty("add")) {
            properties.op = 1;
            if (!(message.add && typeof message.add.length === "number" || $util.isString(message.add)))
                return "add: buffer expected";
        }
        if (message["delete"] != null && message.hasOwnProperty("delete")) {
            if (properties.op === 1)
                return "op: multiple values";
            properties.op = 1;
            if (!$util.isString(message["delete"]))
                return "delete: string expected";
        }
        return null;
    };

    /**
     * Creates a CSetMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CSetMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CSetMessage} CSetMessage
     */
    CSetMessage.fromObject = function fromObject(object) {
        if (object instanceof CSetMessage)
            return object;
        let message = new CSetMessage();
        if (object.add != null)
            if (typeof object.add === "string")
                $util.base64.decode(object.add, message.add = $util.newBuffer($util.base64.length(object.add)), 0);
            else if (object.add.length)
                message.add = object.add;
        if (object["delete"] != null)
            message["delete"] = String(object["delete"]);
        return message;
    };

    /**
     * Creates a plain object from a CSetMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CSetMessage
     * @static
     * @param {CSetMessage} message CSetMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CSetMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (message.add != null && message.hasOwnProperty("add")) {
            object.add = options.bytes === String ? $util.base64.encode(message.add, 0, message.add.length) : options.bytes === Array ? Array.prototype.slice.call(message.add) : message.add;
            if (options.oneofs)
                object.op = "add";
        }
        if (message["delete"] != null && message.hasOwnProperty("delete")) {
            object["delete"] = message["delete"];
            if (options.oneofs)
                object.op = "delete";
        }
        return object;
    };

    /**
     * Converts this CSetMessage to JSON.
     * @function toJSON
     * @memberof CSetMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CSetMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CSetMessage;
})();

export const CSetSave = /*@__PURE__*/ (() => {

    /**
     * Properties of a CSetSave.
     * @exports ICSetSave
     * @interface ICSetSave
     * @property {Array.<Uint8Array>|null} [args] CSetSave args
     */

    /**
     * Constructs a new CSetSave.
     * @exports CSetSave
     * @classdesc Represents a CSetSave.
     * @implements ICSetSave
     * @constructor
     * @param {ICSetSave=} [properties] Properties to set
     */
    function CSetSave(properties) {
        this.args = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CSetSave args.
     * @member {Array.<Uint8Array>} args
     * @memberof CSetSave
     * @instance
     */
    CSetSave.prototype.args = $util.emptyArray;

    /**
     * Creates a new CSetSave instance using the specified properties.
     * @function create
     * @memberof CSetSave
     * @static
     * @param {ICSetSave=} [properties] Properties to set
     * @returns {CSetSave} CSetSave instance
     */
    CSetSave.create = function create(properties) {
        return new CSetSave(properties);
    };

    /**
     * Encodes the specified CSetSave message. Does not implicitly {@link CSetSave.verify|verify} messages.
     * @function encode
     * @memberof CSetSave
     * @static
     * @param {ICSetSave} message CSetSave message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CSetSave.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.args != null && message.args.length)
            for (let i = 0; i < message.args.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.args[i]);
        return writer;
    };

    /**
     * Encodes the specified CSetSave message, length delimited. Does not implicitly {@link CSetSave.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CSetSave
     * @static
     * @param {ICSetSave} message CSetSave message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CSetSave.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CSetSave message from the specified reader or buffer.
     * @function decode
     * @memberof CSetSave
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CSetSave} CSetSave
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CSetSave.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new CSetSave();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.args && message.args.length))
                    message.args = [];
                message.args.push(reader.bytes());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CSetSave message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CSetSave
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CSetSave} CSetSave
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CSetSave.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CSetSave message.
     * @function verify
     * @memberof CSetSave
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CSetSave.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.args != null && message.hasOwnProperty("args")) {
            if (!Array.isArray(message.args))
                return "args: array expected";
            for (let i = 0; i < message.args.length; ++i)
                if (!(message.args[i] && typeof message.args[i].length === "number" || $util.isString(message.args[i])))
                    return "args: buffer[] expected";
        }
        return null;
    };

    /**
     * Creates a CSetSave message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CSetSave
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CSetSave} CSetSave
     */
    CSetSave.fromObject = function fromObject(object) {
        if (object instanceof CSetSave)
            return object;
        let message = new CSetSave();
        if (object.args) {
            if (!Array.isArray(object.args))
                throw TypeError(".CSetSave.args: array expected");
            message.args = [];
            for (let i = 0; i < object.args.length; ++i)
                if (typeof object.args[i] === "string")
                    $util.base64.decode(object.args[i], message.args[i] = $util.newBuffer($util.base64.length(object.args[i])), 0);
                else if (object.args[i].length)
                    message.args[i] = object.args[i];
        }
        return message;
    };

    /**
     * Creates a plain object from a CSetSave message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CSetSave
     * @static
     * @param {CSetSave} message CSetSave
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CSetSave.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.args = [];
        if (message.args && message.args.length) {
            object.args = [];
            for (let j = 0; j < message.args.length; ++j)
                object.args[j] = options.bytes === String ? $util.base64.encode(message.args[j], 0, message.args[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.args[j]) : message.args[j];
        }
        return object;
    };

    /**
     * Converts this CSetSave to JSON.
     * @function toJSON
     * @memberof CSetSave
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CSetSave.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CSetSave;
})();

export { $root as default };
